// import React, { useState, useRef, useEffect } from 'react';
// import { useNavigate } from "react-router-dom";
// import {
//   Slide,
//   IconButton,
//   ClickAwayListener,
//   InputBase,
//   Button,
//   Grid,
//   Stack,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
//   Paper,
//   Tabs,
//   Tab,
//   Box,
//   Modal,
//   Divider,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Select,
//   TextField,
//   FormControlLabel,
//   RadioGroup,
//   Radio,
//   Checkbox,
//   ListItemText,
//   OutlinedInput,
//   Pagination,
//   CircularProgress,
//   Link,
//   Avatar,
//   InputAdornment,
//   Card,
//   CardContent,

// } from '@mui/material';

// import PaginationItem from '@mui/material/PaginationItem';

// import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
// import { styled } from '@mui/material/styles';
// import { Document, Page, pdfjs } from 'react-pdf';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { CopyToClipboard } from 'react-copy-to-clipboard';
// import CustomComplete from '../components/customComplete/CustomComplete';
// import CustomCompleteWorksheet from '../components/customComplete/CustomCompleteWorksheet';
// import Iconify from '../components/iconify';
// // import Upload from '../components/upload';   
// import Scrollbar from '../components/scrollbar/Scrollbar';

// import { Api, UploadFile } from '../webservices';

// const Home = () => {

//   const navigate = useNavigate()
//   const [reviewss, setReviewss] = useState([])
//   const [box, setBox] = useState([])

//   useEffect(() => {
//     getReviews()
//     getBoxLst()
//   }, [])

//   const getReviews = async () => {
//     const token = localStorage.getItem('token');
//     Api(`contact/reviewList`, 'GET', '', token)
//       .then((response) => {
//         if (response.status === 200) {
//           // console.log('=========status 200======>>>>>>>', response);
//           if (response.data.status === 200) {
//             // console.log('city========', JSON.stringify(response.data));
//             setReviewss(response.data.result);
//           }
//         } else {
//           toast.error(response.data.message, +'!');
//         }
//       })
//       .catch((err) => {
//         // console.log('===========', err);
//         // toast.error(err, +'!');
//       });
//   };

//   const getBoxLst = async () => {
//     const token = localStorage.getItem('token');
//     Api(`contact/boxList`, 'GET', '', token)
//       .then((response) => {
//         if (response.status === 200) {
//           // console.log('=========status 200======>>>>>>>', response);
//           if (response.data.status === 200) {
//             // console.log('city========', JSON.stringify(response.data));
//             setBox(response.data.result);
//           }
//         } else {
//           toast.error(response.data.message, +'!');
//         }
//       })
//       .catch((err) => {
//         // console.log('===========', err);  
//         // toast.error(err, +'!');
//       });   
//   };

//   const Review = () => {
//     const body = {
//       "reviewImage": "", 
//       "reviewMessage": "",
//       "reviewRate": "",
//       "reviewPersonName": ""
//     }
//     const token = localStorage.getItem('token');
//     Api('contact/createReview', 'POST', body, token).then((Response) => {
//       console.log("Response", Response)
//       if (Response.status === 200) {
//         if (Response.data.status === 200) {

//           toast.success(Response.data?.resmessage)
//           console.log("Response.data?.resmessage", Response.data?.resmessage)
//         }
//       } else {
//         toast.error(Response.data?.resmessage)

//       }

//     })
//   }

//   const data = [
//     {
//       heading: "Card 1",
//       subject: " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat  sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat  sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo co."
//     },
//     {
//       heading: "Card 2",
//       subject: " magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
//     },
//     {
//       heading: "Card 3",
//       subject: "World History"
//     },
//     {
//       heading: "Card 4",
//       subject: "Literature"
//     },
//     {
//       heading: "Card 5",
//       subject: "Programming"
//     },
//     {
//       heading: "Card 6",
//       subject: "Programming"
//     },
//     {
//       heading: "Card 7",
//       subject: "Programming"
//     }
//   ];

//   const scrollRef = useRef(null);

//   const scrollLeft = () => {
//     if (scrollRef.current) {
//       scrollRef.current.scrollBy({
//         left: -300,
//         behavior: 'smooth',
//       });
//     }
//   };

//   const scrollRight = () => {
//     if (scrollRef.current) {
//       scrollRef.current.scrollBy({
//         left: 300,
//         behavior: 'smooth',
//       });
//     }
//   }

//   const [currentIndex, setCurrentIndex] = useState(0);

//   const handlePrev = () => {
//     if (currentIndex > 0) {
//       setCurrentIndex(currentIndex - 1);
//     }
//   };

//   const handleNext = () => {
//     if (currentIndex + 3 < box?.length) {
//       setCurrentIndex(currentIndex + 1);
//     }
//   };


//   const reviews = [
//     {
//       id: 1,
//       name: 'John Doe',
//       review: 'This is an awesome product! Highly recommended This is an awesome product! Highly recom awesome product! Highly recommended This is an awesome product! Highly recommendedThis is an awesome product! Highly recommendedThis is an awesome product! Highly recommended.',
//       image: 'https://via.placeholder.com/150'
//     },
//     {
//       id: 2,
//       name: 'Jane Smith',
//       review: 'Amazing experience, will definitely buy again.',
//       image: 'https://via.placeholder.com/150'
//     },
//     {
//       id: 3,
//       name: 'Alice Johnson',
//       review: 'Great quality and fast delivery!',
//       image: 'https://via.placeholder.com/150'
//     },
//     {
//       id: 4,
//       name: 'Johnson',
//       review: 'Great quality and fast delivery!',
//       image: 'https://via.placeholder.com/150'
//     }
//   ];

//   return (
//     <>
//       <Stack backgroundColor={'text.secondary'}>
//         <Stack
//           flexDirection={'row'}
//           alignItems={'flex-end'}
//           justifyContent={'space-between'}
//           sx={{
//             padding: 2.1, mt: 1.1, mb: 1.1,
//             flexWrap: 'nowrap', alignItems: 'center',
//             overflow: "hidden",
//           }}
//         >

//           <Stack flexDirection={'row'} gap={3} alignItems="center">
//             {/* <Typography color="white">
//               Foxearch Icon
//             </Typography> */}
//              <img alt="." src="/assets/foxLogo.png" width="150px"/>

//             <Typography color="white" sx={{ ml: 11, cursor: 'pointer' }} onClick={() => navigate('/productDemo')}>
//               Product Demo
//             </Typography>
//             <Typography color="white" sx={{ cursor: 'pointer' }} onClick={() => navigate('/aboutUs')}>
//               About Us
//             </Typography>
//           </Stack>

//           <Stack
//             flexDirection="row"
//             gap={2}
//             sx={{ flexWrap: 'nowrap', alignItems: 'center' }}
//           >
//             {/* <Typography sx={{cursor:"pointer"}}>www icon </Typography> */}
//             <Iconify icon="fontisto:world-o" width="2rem" color="white" sx={{ cursor: "pointer" }} />
//             <Typography color="white" sx={{ cursor: "pointer", marginRight:5 }} onClick={() => navigate('/login')}>Sign In</Typography>
//             <Button
//               sx={{
//                 backgroundColor: "white",
//                 // color: "transparent", 
//                 '&:hover': {
//                   backgroundColor: "white",
//                   // color: "transparent"
//                 }
//               }}
//             >
//               Request Demo
//             </Button>

//           </Stack>

//         </Stack>
//         <Divider sx={{ borderColor: "white" }} />
//         <Stack
//           flexDirection={'row'}
//           alignItems={'flex-end'}
//           justifyContent={'space-between'}
//           sx={{
//             padding: 3, mb: 25,
//             flexWrap: 'nowrap', alignItems: 'center',
//             mt: 5
//           }}
//         >

//           <Stack flexDirection={'column'} sx={{ ml: 6, width:"70%", mt:-30 }}>

//             <Typography color="white" variant="h4" >
//               Simplified One <br />
//               Stop Solution <br /> 
//               for All your hiring Needs
//             </Typography>

//             <Typography color="white" sx={{ mt: 3 }}>
//               Empower Your Team with ATS, VMS, CRM and Sales Management
//             </Typography>
//             <Button
//               sx={{
//                 mt: 4,
//                 backgroundColor: "white",
//                 width: "30%",
//                 // color: "transparent", 
//                 '&:hover': {
//                   backgroundColor: "white",
//                   // color: "transparent"

//                 }
//               }}
//             >
//               Request Demo
//             </Button>
//           </Stack>
//           <Stack
//             flexDirection="row"
//             // gap={}
//             sx={{ flexWrap: 'nowrap', alignItems: 'center', mt:-3 }}
//           >
//             {/* <Typography>-</Typography> */}
//             <img alt="." src="/assets/team.png" width="100%"/>

//           </Stack>
//         </Stack> 
//       </Stack>
//       <Stack
//         justifyContent="center"
//         alignItems="center"
//         sx={{
//           backgroundColor: 'white',
//           width: '95%',
//           margin: '0 auto',
//           padding: 5,
//           position: 'relative',
//           overflow: 'hidden',
//           mt: -8,
//           boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.5), 0px -5px 10px rgba(0, 0, 0, 0)'

//         }}
//       >

//         <IconButton
//           onClick={handlePrev}
//           sx={{
//             position: 'absolute',
//             top: '50%',
//             left: '0.5px',
//             transform: 'translateY(-50%)',
//             cursor: 'pointer',
//             zIndex: 1,
//           }}
//           disabled={currentIndex === 0}
//         >
//           <Iconify icon="ep:arrow-left-bold" width="2rem" />
//         </IconButton>

//         <Box
//           sx={{
//             display: 'flex',
//             gap: 2,
//             width: '100%',
//             flexWrap: 'nowrap',
//             justifyContent: 'center',
//           }}
//         >

//           {box?.slice(currentIndex, currentIndex + 3)?.map((item, index) => (
//             <Card
//               key={index}
//               sx={{
//                 width: '38%',
//                 height: '250px',
//                 border: '1.5px solid #3C6BA5',
//                 borderRadius: '8px',
//                 boxShadow: 'none',
//                 display: 'flex',
//                 flexDirection: 'column',
//               }}
//             >
//               <CardContent
//                 sx={{
//                   padding: 2,
//                   display: 'flex',
//                   flexDirection: 'column',
//                   flexGrow: 1,
//                   position: 'relative',
//                   height: '100%',
//                 }}
//               >

//                 <Typography
//                   color={'text.secondary'}
//                   sx={{
//                     fontSize: 17,
//                     position: 'sticky',
//                     top: 0,
//                     zIndex: 1,
//                     backgroundColor: 'white',
//                   }}
//                 >
//                   {item?.title}
//                 </Typography>

//                 <Typography
//                   variant="body2"
//                   sx={{
//                     mt: 1.5,
//                     overflowY: 'auto',
//                     flexGrow: 1,
//                   }}
//                 >
//                   {/* <Scrollbar sx={{ maxHeight: 300, scrollbar: 'thin' }}> */}
//                   {item?.description}
//                   {/* </Scrollbar> */}
//                 </Typography>

//                 <Typography
//                   color={'text.secondary'}
//                   sx={{
//                     mt: 1.5,
//                     fontSize: 17,
//                     position: 'sticky',
//                     bottom: 0,
//                     backgroundColor: 'white',
//                     padding: '1px 0',
//                     zIndex: 1,
//                     cursor: 'pointer',
//                   }}
//                 >
//                   Explore More
//                 </Typography>
//               </CardContent>
//             </Card>
//           ))}

//         </Box>

//         <IconButton
//           onClick={handleNext}
//           sx={{
//             position: 'absolute',
//             top: '50%',
//             right: '0.5px',
//             transform: 'translateY(-50%)',
//             cursor: 'pointer',
//             zIndex: 1,
//           }}
//           disabled={currentIndex + 3 >= box?.length}
//         >
//           <Iconify icon="ep:arrow-right-bold" width="2rem" />
//         </IconButton>
//       </Stack>

//       <Stack
//         flexDirection={'row'}
//         alignItems={'flex-end'}
//         justifyContent={'space-between'}
//         sx={{
//           padding: 3,
//           flexWrap: 'nowrap', alignItems: 'center',
//           mt: 8
//         }}
//       >

//         <Stack flexDirection={'column'} sx={{ ml: 3, width:"100%" }}>

//           <Typography color={'text.secondary'} variant="h4" >
//             Whatever your fuctions are we got it <br />
//             All covered Recruitment/ <br />
//             Management/Sales Work, Track & <br />
//             Mange all at one place
//           </Typography>

//           <Typography sx={{ mt: 3 }}>
//             Introducing our innovatives smart worksheet, meticulously crafted for <br />
//             professionals across varoius domains including Recruitment, Sales and <br />
//             Management. no longer will you need to navigate through scattered data <br />
//             source or hunt for solutions
//           </Typography>

//         </Stack>
//         <Stack
//           flexDirection="row" 

//           sx={{ flexWrap: 'nowrap', alignItems: 'center', ml:15 }}
//         >

//           <img alt="." src="/assets/work.png" width="90%"/>


//         </Stack>
//       </Stack>

//       {/* <Stack 
//  flexDirection={'row'}
//  alignItems={'flex-end'}
//  justifyContent={'space-between'}
//  sx={{ padding: 3,
//     flexWrap: 'nowrap', alignItems: 'center',
//     mt:8,
//     backgroundColor:'rgba(82, 130, 210, 0.09)'
//   }}
//  >

// <Stack flexDirection={'column'} sx={{ml:4}}>

// <Typography 
//   variant="h6" 
//   backgroundColor={'text.secondary'} 
//   sx={{ 
//     color: "white", 
//     borderRadius: "25px", 
//     padding: "10px 20px",  
//     textAlign: "center",   
//     display: "flex",       
//     alignItems: "center",  
//     justifyContent: "center",
// mt:5

//   }}
// >
//   WHAT USERS ARE SAYING
// </Typography>


//      <Typography  sx={{mt:3}}>
//      The Successfully Story Of Our Client
//       </Typography>
//      <Typography  sx={{mt:3}}>
//      Lorem ipsum dolor sit amet, consectetur adipiscing elit, <br/>
//      Lorem ipsum dolor sit amet, consectetur.
//       </Typography>

// </Stack>
// <Stack
//   flexDirection="row"
//   gap={2}
//   sx={{ flexWrap: 'nowrap', alignItems: 'center' }}
// >
// <Typography>-</Typography>

// </Stack>
// </Stack> */}

//       <Stack
//         sx={{
//           padding: 3,
//           alignItems: 'center',
//           mt: 8,

//           // backgroundColor: 'rgba(82, 130, 210, 0.09)' 
//           backgroundColor: '#EAF1FE'
//         }}
//       >
//         <Stack flexDirection={'column'} sx={{ ml: 4 }}>
//           <Typography
//             variant="h6"
//             backgroundColor={'text.secondary'}
//             sx={{
//               color: 'white',
//               borderRadius: '25px',
//               padding: '10px 20px',
//               textAlign: 'center',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               mt: 5,

//             }}
//           >
//             WHAT USERS ARE SAYING
//           </Typography>
//         </Stack>

//         <Stack
//           flexDirection={'row'}
//           sx={{ mt: 3, gap: 2, mb: 4 }}
//         >
//           {reviewss?.map((item) => (
//             <Card
//               key={item.id}
//               sx={{
//                 p: 2,
//                 // backgroundColor: 'text.secondary', 
//                 // color: 'white', 
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 width: 250,
//                 height: 300,
//                 overflow: 'hidden',
//                 // gap:3
//                 border: '1.5px solid #3C6BA5'
//               }}
//             >
//               <Stack flexDirection="column" alignItems="center" sx={{ height: '100%' }}>
//                 <Avatar
//                   src={item?.reviewImage}
//                   alt={item?.reviewPersonName}
//                   sx={{ width: 90, height: 90 }}
//                 />
//                 <Typography variant="h6" align="center" sx={{ mt: 1.5, mb: 1, fontWeight: "bold", color: "#3C6BA5" }}>
//                   {item?.reviewPersonName}
//                 </Typography>
//                 <div
//                   style={{
//                     maxHeight: '150px',
//                     overflowY: 'auto',
//                     paddingRight: '8px'
//                   }}
//                 >
//                   <Typography variant="body2" align="center">
//                     {item?.reviewMessage}
//                   </Typography>
//                   <Typography variant="body2" align="center" sx={{ fontSize: "22px" }}>
//                     {Array.from({ length: 5 }, (_, index) => (
//                       <span
//                         key={index}
//                         style={{
//                           color: index < item?.reviewRate ? "#3C6BA5" : 'gray',
//                         }}
//                       >
//                         {index < item?.reviewRate ? '★' : '☆'}
//                       </span>
//                     ))}
//                   </Typography>


//                 </div>
//               </Stack>
//             </Card>
//           ))}
//         </Stack>
//       </Stack>

//       <Stack
//         flexDirection={'row'}
//         alignItems={'flex-end'}
//         justifyContent={'space-between'}
//         sx={{
//           padding: 3,
//           flexWrap: 'nowrap', alignItems: 'center',

//           backgroundColor: '#0F1720'
//         }}
//       >

//         <Stack flexDirection={'column'} sx={{ ml: 2, width:"100%" }}>

//           <Typography color={'text.secondary'} variant="h4" sx={{ color: "white", mt: 7 }} >
//             Why US
//           </Typography>

//           <Typography sx={{ mt: 3, color: "white" }}>
//             At Foxearch, we understand the unique challenges faced by recruitment and staffing  <br />
//             professionals. That's why we've developed a comprehensive software suite tailored to <br />
//             your needs. With Foxearch, you'll  transform your hiring and client management <br />
//             processes, streamline your sales efforts, and elevate your business to new heights. <br />

//           </Typography>
//           <Typography sx={{ color: "white", mt: 3, mb: 9 }}>
//             While the market solely focuses on outcomes, disregarding the process-oriented <br />
//             hierarchy and importance of professionals' routine tasks, we ensure meticulous <br />
//             recording and accountability of every professional’s action and connection. We make <br />
//             sure all the information is automated and presented in a courteous manner since <br />
//             information is the greatest treasure.
//           </Typography>

//         </Stack>
//         <Stack
//           flexDirection="row"
//           gap={2}
//           sx={{ flexWrap: 'nowrap', alignItems: 'center' , ml:20 }}
//         >
//           {/* <Typography>-</Typography> */}
//           <img alt="." src="/assets/world.png" width="95%"/>


//         </Stack>
//       </Stack>


//       <Stack
//         flexDirection={'row'}
//         alignItems={'flex-end'}
//         justifyContent={'space-between'}
//         sx={{
//           padding: 3,
//           flexWrap: 'nowrap', alignItems: 'center',

//           // backgroundColor: '#0F1720' 
//         }} 
//       >

//         <Stack
//           flexDirection="row"
//           gap={2}
//           sx={{ flexWrap: 'nowrap', alignItems: 'center', mt:8, ml:6 ,

//           }}
//         >
//           {/* <Typography>-</Typography> */}
//           {/* <img alt="." src="/assets/cards.png" width="50%"/>
//           <img alt="." src="/assets/hr.png" width="50%"/> */}

// <Box sx={{ position: "relative", width: "70%" }}>
//       {/* Background Image */}
//       <Box
//         component="img"
//         src="/assets/cards.png"
//         alt="Cards"
//         sx={{ width: "100%", display: "block" }}
//       />

//       {/* Overlay Image */}
//       <Box
//         component="img"
//         src="/assets/hr.png"
//         alt="HR"
//         sx={{
//           position: "absolute",
//           top: "35%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           width: "60%", // Adjust as needed
//         }}
//       />
//     </Box>

//         </Stack>
//         <Stack flexDirection={'column'} sx={{width:"70%"}}>

//           <Typography color={'text.secondary'} variant="h4" sx={{ mt: 7 }} >
//             Security
//           </Typography>

//           <Typography sx={{ mt: 3 }}>
//             We understand that security is paramount when handling sensitive data. <br />
//             Foxearch employs state-of-the-art security measures to ensure your data <br />
//             remains confidential and protected at all times. Rest easy knowing your <br />
//             business is in safe hands.
//           </Typography>
//           <Typography sx={{ mt: 3, mb: 2 }}>
//             Join the ranks of recruitment and staffing professionals who've experienced <br />
//             the Foxearch advantage. Streamline your processes, maximize your results, <br />
//             and scale your business with confidence.
//           </Typography>

//           <Typography sx={{ mt: 2 }}>
//             Ready to see how Foxearch can transform your recruitment and staffing <br />
//             operations? Contact us for a personalized demo today!
//           </Typography>
//           <Button
//             color="custom"
//             variant="contained"
//             sx={{
//               width: '30%',
//               padding: '9px 16px',
//               mt: 2
//             }}
//           >
//             Request Demo
//           </Button>

//         </Stack>
//       </Stack>

//     </>
//   );
// };

// export default Home;

import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';

import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Container,
  Divider,
} from "@mui/material";

import Header from './Header'
import Footer from './Footer'
// import MenuIcon from "@mui/icons-material/Menu";
// import CloseIcon from "@mui/icons-material/Close";
// import SearchIcon from "@mui/icons-material/Search";
// import PhoneIcon from "@mui/icons-material/Phone";

const Home = () => {
  const navigate = useNavigate()

  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const menuItems = [
    { name: "Home", link: "/" },
    { name: "About", link: "/about" },
    {
      name: "Services",
      subItems: [
        { name: "Services 1", link: "/services-1" },
        { name: "Services 2", link: "/services-2" },
        { name: "Services 3", link: "/services-3" },
        { name: "Services 4", link: "/services-4" },
      ],
    },
    {
      name: "Works",
      subItems: [
        { name: "Regular", link: "/portfolio-regular" },
        { name: "Extended", link: "/portfolio-extended" },
        { name: "Fullwidth", link: "/portfolio-fullwidth" },
      ],
    },
    {
      name: "Pages",
      subItems: [
        { name: "Helpdesk", link: "/helpdesk" },
        { name: "Our Story", link: "/our-story" },
        { name: "Careers", link: "/careers" },
        {
          name: "Our Team",
          subItems: [
            { name: "Our Team 1", link: "/our-team-1" },
            { name: "Our Team 2", link: "/our-team-2" },
          ],
        },
      ],
    },
    { name: "Blog", link: "/blog" },
    { name: "Contacts", link: "/contacts" },
  ];

  const renderMenuItems = (items) => {
    return items.map((item, index) => (
      <div key={index}>
        {item.subItems ? (
          <>
            <Typography variant="h6" sx={{ p: 2 }}>
              {item.name}
            </Typography>
            <List>{renderMenuItems(item.subItems)}</List>
          </>
        ) : (
          <ListItem button component="a" href={item.link}>
            <ListItemText primary={item.name} />
          </ListItem>
        )}
        <Divider />
      </div>
    ));
  };

  return (
    <>
      {/* <AppBar
        position="static"
        sx={{
          backgroundColor: "#191f28",
          boxShadow: "none",
          padding: "10px 0",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
        
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <img
              src="./assets/logoBlue.svg"
              alt="DeepDigital Logo"
              style={{ height: "40px", marginRight: "10px" }}
            />
            
          </Box>

          <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
            {menuItems.map((item, index) => (
              <Button
                key={index}
                color="inherit"
                sx={{ mx: 1, textTransform: "none" }}
              >
                {item.name}
              </Button>
            ))}
            
          </Box>

          
        </Toolbar>

        <Drawer
          anchor="right"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          sx={{ display: { xs: "block", md: "none" } }}
        >
          <Box sx={{ width: 250 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                p: 2,
              }}
            >
             
            </Box>
            <List>{renderMenuItems(menuItems)}</List>
          </Box>
        </Drawer>
      </AppBar> */}

      {/* <div id="header-affix-wrap" className="header-wrap i  ">
            <header id="header" className="header header-6 i fs-12 menu-center always-sticky    has-menu">
              <div className="container-fluid">
                <div className="logo-wrap">
                  <a className="logo logo-left with-image" href="/" itemProp="url">
                    <img
                    src="./assets/logoBlue.svg"
              alt="DeepDigital Logo"
              />
                   
                  </a>				</div>
                <div id="overlay" />
                <nav id="nav_top" className="top-nav" aria-label="Top Menu">
                  <ul id="menu-main-menu" className="top-menu menu-many-items"><li id="menu-item-1350" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-1350"><a href="#" aria-current="page" data-hover="Home">Home</a></li>
                    <li id="menu-item-9259" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-9259"><a href="#" data-hover="Services">Product Demo</a></li>
                    <li id="menu-item-1321" className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-1277 current_page_item menu-item-1321"><a href="aboutUs" data-hover="About">About Us</a></li>
                    
                    <li id="menu-item-1314" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-1314"><a href="#" data-hover="Pages">Careers</a>
                      
                    </li>
                    <li id="menu-item-9285" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-9285"><a href="blogs" data-hover="Blog">Blogs</a>
                      
                    </li>
                    <li id="menu-item-9286" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-9286"><a href="#" data-hover="Contacts">Contact Us</a>
                      
                    </li>
                  </ul>							<button id="nav_close" className="nav-btn" aria-controls="nav_top" aria-expanded="true" aria-label="Top Menu Close" />

                 
                </nav>
                <button id="nav_toggle" className="nav-btn" aria-controls="nav_top" aria-expanded="false" aria-label="Top Menu Toggler" />

              </div>
            </header>
          </div> */}
      <Header />
      <Box
        sx={{
          position: "relative",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          top: "-75px"
        }}
      >
        <Box
          component="img"
          src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/06/pattern-2.png"
          alt="Background Pattern"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 1,
            backgroundColor: '#000000ab',
            'clip-path': 'polygon(0% 0%, 0% 94.2%, 50% 100%, 100% 94.2%, 100% 0%)',
          }}
        />

        <Box
          component="video"
          autoPlay
          loop
          muted
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 0,
            filter: "blur(1px)",
            'clip-path': "polygon(0% 0%, 0% 94.2%, 50% 100%, 100% 94.2%, 100% 0%)"
          }}
        >
          <source
            src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/dotdigital-video.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </Box>

        <Container
          sx={{
            position: "relative",
            zIndex: 1,
            textAlign: "center",
            color: "#fff",
            marginBottom: '-170px'
          }}
        >
          {/* <Typography
            variant="h6"
            sx={{
              fontSize: "14px",
              fontWeight: 700,
              letterSpacing: "28px",
              textTransform: "uppercase",
              mb: 2,
            }}
          >
            WELCOME TO
          </Typography> */}

          <Typography

            // variant="h5"
            sx={{
              fontSize: { xs: "10px", md: "90px" },
              fontWeight: "600",
              letterSpacing: "4px",
              mb: 2,
              color: '#fff'
            }}
          >
            {/* IT AGENCY */}
            ATS <b className="medium highlight">|</b> VMS <b className="medium highlight">|</b> CRM

          </Typography>

          <Typography

            variant="h5"
            sx={{
              // fontSize: { xs: "10px", md: "50px" },
              fontWeight: "600",
              letterSpacing: "4px",
              mb: 10,
              color: "#ff497c"
            }}
          >

            An Ultimate Destination for All Your Hiring Endeavours
          </Typography>

          {/* <Typography
            variant="h4"
            sx={{
              fontSize: { xs: "24px", md: "54px" },
              fontWeight: 200,
              letterSpacing: "4px",
              mb: 4,
            }}
          >
            <span style={{ color: "#a0ce4e" }}>Web Design</span>,{" "}
            <span style={{ color: "#00bea3" }}>Marketing</span> &amp;{" "}
            <span style={{ color: "#f1894c" }}>Branding</span>
          </Typography> */}

          <Button
            variant="contained"
            sx={{
              backgroundColor: "#ff497c",
              color: "#fff",
              fontSize: "16px",
              fontWeight: 600,
              width: '150px',
              padding: "15px 30px",
              borderRadius: "50px",
              position: "relative",
              lineHeight:'2.4',
              overflow: "hidden",
              "&:hover": {
                backgroundColor: "#e03e6b",
              },
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: "-10px",
                left: "50%",
                transform: "translateX(-50%)",
                lineHeight:'2.4',
                width: "120%",
                height: "20px",
                backgroundColor: "#ff497c",
                borderRadius: "50%",
                zIndex: -1,
              },
            }}
           onClick={()=>navigate('/login')}
          >
          Login
          </Button>
        </Container>

      </Box>

      <div id="body" className="home page-template page-template-page-templates page-template-full-width page-template-page-templatesfull-width-php page page-id-1196 wp-custom-logo theme-deepdigital woocommerce-no-js tribe-no-js page-template-deepdigital yith-wcbm-theme-deepdigital singular no-sidebar container-1170 meta-icons-main woo header-sticky animation-enabled title-hidden elementor-default elementor-kit-2882 elementor-page elementor-page-1196" itemType="https://schema.org/WebPage" itemScope="itemscope" data-animate='{&quot;.footer-widgets .widget&quot;:&quot;fadeInUp&quot;}'
      >

        {/* <div id="preloader" className="preloader cover">
          <div className="preloader_css" />

        </div> */}


        <button id="login_modal_close" aria-controls="login_dropdown" className="nav-btn" aria-expanded="true" aria-label="Login Toggler">
          {/* <span></span> */}
        </button>
        {/* <div id="box" className="box-fade-in" /> */}


        <div data-elementor-type="wp-page" data-elementor-id="1196" className="elementor elementor-1196">
          <section className="elementor-section elementor-top-section elementor-element elementor-element-37c7607 elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="37c7607" data-element_type="section" id="section1">
            <div className="elementor-container elementor-column-gap-default">
              <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-9bde638" data-id="9bde638" data-element_type="column">
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div className="elementor-element elementor-element-5bda1a1 elementor-widget elementor-widget-spacer" data-id="5bda1a1" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <section className="elementor-section elementor-inner-section elementor-element elementor-element-42fc68c elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="42fc68c" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-a5ba412" data-id="a5ba412" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-e6c6847 elementor-widget elementor-widget-image" data-id="e6c6847" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img decoding="async" width="5" height="94" src="./assets/images/home/vertical_line.png" className="attachment-full size-full wp-image-5974" alt="" />													</div>
                          </div>
                          <div className="elementor-element elementor-element-3ad06eb elementor-widget elementor-widget-spacer" data-id="3ad06eb" data-element_type="widget" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-85611eb elementor-widget elementor-widget-heading" data-id="85611eb" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container" style={{ width: '100%', textAlign: '-webkit-center' }}>
                              <h2 className="elementor-heading-title elementor-size-default" style={{ color: '#3C6BA5', width: '75%' }}>Simplified, AI-Enhanced All-in-One Solution for Your Hiring Needs
                              </h2>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-f5d4b79 elementor-widget elementor-widget-heading" data-id="f5d4b79" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              {/* <h2 className="elementor-heading-title elementor-size-default"></h2>	 */}
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-c9e4eaf elementor-widget elementor-widget-spacer" data-id="c9e4eaf" data-element_type="widget" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-7f8e584 elementor-widget elementor-widget-text-editor" data-id="7f8e584" data-element_type="widget" data-widget_type="text-editor.default">
                            {/* <div className="elementor-widget-container"> */}
                            <div className="nrml_black">
                              At <strong>Foxearch,</strong> we provide a comprehensive recruitment platform that combines the power of ATS, VMS, CRM, and Sales Management tools into one seamless solution. Designed to simplify and streamline your hiring process, our platform empowers your team with the tools they need to succeed—backed by an intuitive interface, advanced features, and a touch of AI innovation.
                            </div>

                          </div>
                          {/* <div className="elementor-element elementor-element-4bdf45c elementor-widget elementor-widget-spacer" data-id="4bdf45c" data-element_type="widget" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div> */}
                          {/* <div className="elementor-element elementor-element-183584e elementor-widget elementor-widget-image" data-id="183584e" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img decoding="async" width="4" height="94" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/vertical_line.png" className="attachment-full size-full wp-image-5974" alt="" />													</div>
                          </div> */}
                          {/* <div className="elementor-element elementor-element-8319a54 elementor-widget elementor-widget-spacer" data-id="8319a54" data-element_type="widget" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div> */}
                          {/* <div className="elementor-element elementor-element-038814f elementor-align-center elementor-widget elementor-widget-button" data-id="038814f" data-element_type="widget" data-widget_type="button.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-button-wrapper">
                                <a className="elementor-button elementor-button-link elementor-size-sm" href="productDemo">
                                  <span className="elementor-button-content-wrapper">
                                    <span className="elementor-button-text">Get Started</span>
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div> */}
                          {/* <div className="elementor-element elementor-element-82e8b6b elementor-widget elementor-widget-spacer" data-id="82e8b6b" data-element_type="widget" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div> */}
                          {/* <div className="elementor-element elementor-element-c0ad0c1 elementor-widget elementor-widget-image" data-id="c0ad0c1" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img decoding="async" width="4" height="94" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/vertical_line.png" className="attachment-full size-full wp-image-5974" alt="" />													</div>
                          </div> */}
                          {/* <div className="elementor-element elementor-element-79e3193 elementor-widget elementor-widget-spacer" data-id="79e3193" data-element_type="widget" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </section>
                  {/* <section className="elementor-section elementor-inner-section elementor-element elementor-element-43e9f3a elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="43e9f3a" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-6f7a251" data-id="6f7a251" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-72b9a93 elementor-widget__width-initial elementor-widget elementor-widget-image" data-id="72b9a93" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <a href="">
                                <img 
                                // fetchpriority="high" 
                                {...{ fetchPriority: "high" }}
                                decoding="async"
                                 width="240" height="240" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_1-1.png" className="attachment-medium size-medium wp-image-6008" alt="" srcSet="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_1-1.png 240w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_1-1-150x150.png 150w" sizes="(max-width: 240px) 100vw, 240px" />								</a>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-43c275e elementor-widget elementor-widget-heading" data-id="43c275e" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default"><a href="">Marketing</a></h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-d37885d elementor-widget elementor-widget-text-editor" data-id="d37885d" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">
                              We use strategic marketing tactics that have been proven to work.						</div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-2262586" data-id="2262586" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-b745ceb elementor-widget__width-initial elementor-widget elementor-widget-image" data-id="b745ceb" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <a href="">
                                <img decoding="async" width="240" height="240" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_2-1.png" className="attachment-medium size-medium wp-image-6009" alt="" srcSet="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_2-1.png 240w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_2-1-150x150.png 150w" sizes="(max-width: 240px) 100vw, 240px" />								</a>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-1476b90 elementor-widget elementor-widget-heading" data-id="1476b90" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default"><a href="">Development</a></h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-65d7e18 elementor-widget elementor-widget-text-editor" data-id="65d7e18" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">
                              Custom programming for most complex functions you can think.						</div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-94ee901 elementor-hidden-tablet elementor-hidden-mobile" data-id="94ee901" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-e3f54f1 elementor-widget__width-initial elementor-widget elementor-widget-image" data-id="e3f54f1" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <a href="">
                                <img loading="lazy" decoding="async" width="240" height="240" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_3-1.png" className="attachment-medium size-medium wp-image-6010" alt="" srcSet="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_3-1.png 240w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_3-1-150x150.png 150w" sizes="(max-width: 240px) 100vw, 240px" />								</a>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-f9d5b51 elementor-widget elementor-widget-heading" data-id="f9d5b51" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default"><a href="">Web Design</a></h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-9d465d0 elementor-widget elementor-widget-text-editor" data-id="9d465d0" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">
                              Powerful web design that will out-perform your strongest competitors.						</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section> */}
                  {/* <section className="elementor-section elementor-inner-section elementor-element elementor-element-35b2dd4 elementor-hidden-widescreen elementor-hidden-desktop elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="35b2dd4" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-8b8650a" data-id="8b8650a" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-98aa9bc elementor-widget__width-initial elementor-widget elementor-widget-image" data-id="98aa9bc" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <a href="">
                                <img loading="lazy" decoding="async" width="240" height="240" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_3-1.png" className="attachment-medium size-medium wp-image-6010" alt="" srcSet="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_3-1.png 240w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_3-1-150x150.png 150w" sizes="(max-width: 240px) 100vw, 240px" />								</a>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-6b855cf elementor-widget elementor-widget-heading" data-id="6b855cf" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default"><a href="">Web Design</a></h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-3589ed8 elementor-widget elementor-widget-text-editor" data-id="3589ed8" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">
                              Powerful web design that will out-perform your strongest competitors.						</div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-ce686a3" data-id="ce686a3" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-464db1a elementor-widget__width-initial elementor-widget elementor-widget-image" data-id="464db1a" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <a href="">
                                <img loading="lazy" decoding="async" width="240" height="240" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_4-1.png" className="attachment-medium size-medium wp-image-6011" alt="" srcSet="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_4-1.png 240w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_4-1-150x150.png 150w" sizes="(max-width: 240px) 100vw, 240px" />								</a>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-889eb60 elementor-widget elementor-widget-heading" data-id="889eb60" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default"><a href="">SEO Optimization</a></h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-5d128d2 elementor-widget elementor-widget-text-editor" data-id="5d128d2" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">
                              Optimizing our web designs to rank on the first page of google is our specialty.						</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section> */}
                  {/* <div className="elementor-element elementor-element-c61ba1b elementor-hidden-tablet elementor-hidden-mobile elementor-widget elementor-widget-spacer" data-id="c61ba1b" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div> */}
                  {/* <section className="elementor-section elementor-inner-section elementor-element elementor-element-1cfd5c9 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="1cfd5c9" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-b9f4968 elementor-hidden-tablet elementor-hidden-mobile" data-id="b9f4968" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-ffac8cb elementor-widget__width-initial elementor-widget elementor-widget-image" data-id="ffac8cb" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <a href="">
                                <img loading="lazy" decoding="async" width="240" height="240" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_4-1.png" className="attachment-medium size-medium wp-image-6011" alt="" srcSet="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_4-1.png 240w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_4-1-150x150.png 150w" sizes="(max-width: 240px) 100vw, 240px" />								</a>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-a5dfbfc elementor-widget elementor-widget-heading" data-id="a5dfbfc" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default"><a href="">SEO Optimization</a></h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-b4caa3d elementor-widget elementor-widget-text-editor" data-id="b4caa3d" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">
                              Optimizing our web designs to rank on the first page of google is our specialty.						</div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-61d9d4e" data-id="61d9d4e" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-1e01719 elementor-widget__width-initial elementor-widget elementor-widget-image" data-id="1e01719" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <a href="">
                                <img loading="lazy" decoding="async" width="240" height="240" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_5-1.png" className="attachment-medium size-medium wp-image-6012" alt="" srcSet="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_5-1.png 240w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_5-1-150x150.png 150w" sizes="(max-width: 240px) 100vw, 240px" />								</a>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-953e7fd elementor-widget elementor-widget-heading" data-id="953e7fd" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default"><a href="">Ecommerce</a></h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-13c9b33 elementor-widget elementor-widget-text-editor" data-id="13c9b33" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">
                              We build your online store using a flexible, modular platform that allows you to expand…						</div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-da7942b" data-id="da7942b" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-60d1515 elementor-widget__width-initial elementor-widget elementor-widget-image" data-id="60d1515" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <a href="">
                                <img loading="lazy" decoding="async" width="240" height="240" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_6-1.png" className="attachment-medium size-medium wp-image-6013" alt="" srcSet="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_6-1.png 240w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/service_icon_6-1-150x150.png 150w" sizes="(max-width: 240px) 100vw, 240px" />								</a>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-8eb7c46 elementor-widget elementor-widget-heading" data-id="8eb7c46" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default"><a href="">Branding</a></h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-84709ed elementor-widget elementor-widget-text-editor" data-id="84709ed" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">
                              A solid brand strategy, logo and guidelines help you to get You recognized.						</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section> */}

                  <div className="elementor-element elementor-element-6cfd2fd elementor-widget elementor-widget-spacer" data-id="6cfd2fd" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div className="elementor-element elementor-element-b3a77e5 elementor-widget elementor-widget-image" data-id="b3a77e5" data-element_type="widget" data-widget_type="image.default" style={{ 'z-index': 2 }}>
                    <div className="elementor-widget-container">
                      <img loading="lazy" decoding="async" width="5" height="134" src="./assets/images/home/vertical_line.png" className="attachment-full size-full wp-image-6726" style={{ position: 'relative', 'z-index': '2' }} alt="" />													</div>
                  </div>
                  <section className="elementor-section elementor-inner-section elementor-element elementor-element-f1976f0 elementor-section-full_width elementor-hidden-mobile elementor-section-height-default elementor-section-height-default" data-id="f1976f0" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-7588e12" data-id="7588e12" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-d7f198a elementor-absolute e-transform elementor-widget elementor-widget-spacer" data-id="d7f198a" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;,&quot;_transform_skewY_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:-3,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_widescreen&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_tablet&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_mobile&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_widescreen&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_tablet&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_mobile&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="spacer.default">
                            <div className="elementor-widget-container" style={{ 'background-color': '#f9fafb' }}>
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-d527e8e" data-id="d527e8e" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-98a8dd3 elementor-absolute e-transform elementor-widget elementor-widget-spacer" data-id="98a8dd3" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;,&quot;_transform_skewY_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:3,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_widescreen&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_tablet&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_mobile&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_widescreen&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_tablet&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_mobile&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="spacer.default">
                            <div className="elementor-widget-container" style={{ 'background-color': '#f9fafb' }}>
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </section>




          <section className="elementor-section elementor-top-section elementor-element elementor-element-7276a38 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="7276a38" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;classNameic&quot;}">
            <div className="elementor-container elementor-column-gap-default">
              <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-bdc2f38" data-id="bdc2f38" data-element_type="column">
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div className="elementor-element elementor-element-29f686b elementor-widget elementor-widget-spacer" data-id="29f686b" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div className="elementor-element elementor-element-22e819f elementor-widget elementor-widget-image" data-id="22e819f" data-element_type="widget" data-widget_type="image.default">
                    <div className="elementor-widget-container">
                      <img loading="lazy" decoding="async" width="5" height="94" src="./assets/images/home/vertical_line3.png" className="attachment-large size-large wp-image-6056" alt="" />													</div>
                  </div>
                  <div className="elementor-element elementor-element-edbaff0 elementor-widget elementor-widget-spacer" data-id="edbaff0" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <section className="elementor-section elementor-inner-section elementor-element elementor-element-a1f96d8 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="a1f96d8" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-ace5f99" data-id="ace5f99" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-c423f8e elementor-view-stacked elementor-shape-circle elementor-widget elementor-widget-icon" style={{ 'text-align': 'center' }} data-id="c423f8e" data-element_type="widget" data-widget_type="icon.default">
                            <img src="./assets/images/home/ATS.png" width="1024" height="1024" alt="SOS" className="hm_cr" />
                          </div>
                          <div className="elementor-element elementor-element-d9d7571 elementor-widget elementor-widget-heading" data-id="d9d7571" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default" style={{ color: '#3c6ba5' }}>ATS</h2> <h2 style={{ color: '#3c6ba5' }} className="elementor-heading-title elementor-size-default">Applicant Tracking System
                              </h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-dae59b9 elementor-widget elementor-widget-text-editor" data-id="dae59b9" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">

                              Recruiting is your expertise, and Foxearch is the tool that takes it to the next level. Our AI-powered ATS simplifies every aspect of the hiring process ensuring you stay organized and collaborate effortlessly. With intelligent candidate mapping, real-time dashboards, and a user-friendly interface, Foxearch empowers you to find the perfect candidates faster and transform your recruitment process into a seamless and efficient experience.


                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-12f7cb6" data-id="12f7cb6" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-c423f8e elementor-view-stacked elementor-shape-circle elementor-widget elementor-widget-icon" style={{ 'text-align': 'center' }} data-id="c423f8e" data-element_type="widget" data-widget_type="icon.default">
                            <img src="./assets/images/home/ai_powered_ats.jpg" width="1024" height="1024" alt="VMS" className="hm_cr" />
                          </div>
                          <div className="elementor-element elementor-element-ec71f62 elementor-widget elementor-widget-heading" data-id="ec71f62" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container" style={{ color: '#3c6ba5' }}>
                              <h2 className="elementor-heading-title elementor-size-default" style={{ color: '#3c6ba5' }}>VMS/CRM</h2><h2 style={{ color: '#3c6ba5' }} className="elementor-heading-title elementor-size-default">Vendor Management System
                              </h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-c32f938 elementor-widget elementor-widget-text-editor" data-id="c32f938" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">

                              Effortlessly manage your clients, job postings, and vendor relationships with Foxearch's VMS/CRM. Designed for seamless efficiency, our system enables you to oversee multiple clients, monitor vendor performance, and ensure timely candidate delivery—all from a single, intuitive platform. With real-time tracking and centralized data management, Foxearch eliminates administrative complexities, allowing you to focus on building stronger client and vendor relationships.

                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-daa7569" data-id="daa7569" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-c423f8e elementor-view-stacked elementor-shape-circle elementor-widget elementor-widget-icon" style={{ 'text-align': 'center' }} data-id="c423f8e" data-element_type="widget" data-widget_type="icon.default">
                            <img src="./assets/images/home/SOS-.png" width="1024" height="1024" alt="SOS" className="hm_cr" />
                          </div>
                          <div className="elementor-element elementor-element-42176b7 elementor-widget elementor-widget-heading" data-id="42176b7" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default" style={{ color: '#3c6ba5' }}>SOS</h2><h2 className="elementor-heading-title elementor-size-default" style={{ color: '#3c6ba5' }}>Sales Optimization System</h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-5e82667 elementor-widget elementor-widget-text-editor" data-id="5e82667" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">

                              Elevate your sales operations and client relationship management with Foxearch's SOS (Sales Optimization System). Specifically designed for recruitment and staffing companies, this powerful system simplifies every aspect of the sales process—from tracking leads to managing client communications. With its intuitive interface, Foxearch's SOS ensures seamless collaboration, enhanced client engagement, and real-time insights into sales performance.

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <div className="elementor-element elementor-element-a7fada6 elementor-widget elementor-widget-spacer" data-id="a7fada6" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div className="elementor-element elementor-element-d0fb4ba elementor-widget elementor-widget-image" data-id="d0fb4ba" data-element_type="widget" data-widget_type="image.default">
                    <div className="elementor-widget-container">
                      <img loading="lazy" decoding="async" width="5" height="94" src="./assets/images/home/vertical_line.png" className="attachment-large size-large wp-image-6056" style={{ position: 'relative', 'z-index': '2', 'margin-bottom': '8px' }} alt="" />													</div>
                  </div>
                  {/* <div className="elementor-element elementor-element-70b91a1 elementor-widget elementor-widget-spacer" data-id="70b91a1" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </section>

          <section className="elementor-section elementor-top-section elementor-element elementor-element-fbf1854 elementor-section-full_width skew_top skew_bottom elementor-section-height-default elementor-section-height-default" data-id="fbf1854" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;classNameic&quot;}">
            <div className="elementor-container elementor-column-gap-default">
              <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ad805f1" data-id="ad805f1" data-element_type="column">
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div className="elementor-element elementor-element-206ddfc elementor-widget elementor-widget-image" data-id="206ddfc" data-element_type="widget" data-widget_type="image.default">
                    <div className="elementor-widget-container">
                      <img loading="lazy" decoding="async" width="5" height="134" src="./assets/images/home/white_line_big.png" className="attachment-full size-full wp-image-6727" alt="" />													</div>
                  </div>
                  <div className="elementor-element elementor-element-31dc388 elementor-widget elementor-widget-spacer" data-id="31dc388" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <section className="elementor-section elementor-inner-section elementor-element elementor-element-620c465 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="620c465" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-c09ff5c" data-id="c09ff5c" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-c178b12 elementor-widget elementor-widget-heading" data-id="c178b12" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default" style={{ color: '#ed457a' }}>01</h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-be5f8c4 elementor-absolute e-transform elementor-widget elementor-widget-heading" data-id="be5f8c4" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;,&quot;_transform_translateY_effect&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:-50,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_tablet&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_mobile&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_widescreen&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_widescreen&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">Smart Worksheets </h2>		</div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-b855771" data-id="b855771" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-65558ee elementor-widget elementor-widget-image" data-id="65558ee" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img loading="lazy" decoding="async" width="800" height="800" src="./assets/images/home/smartSheet.jpg" className="attachment-deepdigital-square size-deepdigital-square wp-image-6060" alt="" srcSet="./assets/images/home/smartSheet.jpg 150w" sizes="(max-width: 800px) 100vw, 800px" />													</div>
                          </div>
                          <div className="elementor-element elementor-element-63fc73d elementor-widget__width-initial elementor-absolute elementor-hidden-tablet elementor-hidden-mobile elementor-widget elementor-widget-image" data-id="63fc73d" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;}" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img loading="lazy" decoding="async" width="34" height="136" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/right_arrow.png" className="attachment-full size-full wp-image-6486" alt="" />													</div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-7956153" data-id="7956153" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-3e69246 elementor-widget elementor-widget-text-editor" data-id="3e69246" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">
                              Foxearch's Smart Worksheets (Sales / Recruitment / Bench) are designed to eliminate redundancies and streamline workflows across Sales, Recruitment, and Bench processes.
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </section>
                  <div className="elementor-element elementor-element-e3c9920 elementor-widget elementor-widget-spacer" data-id="e3c9920" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <section className="elementor-section elementor-inner-section elementor-element elementor-element-5888b09 elementor-reverse-mobile elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="5888b09" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-035c8fd" data-id="035c8fd" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-547b92d elementor-widget elementor-widget-text-editor" data-id="547b92d" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">
                              Foxearch leverages advanced AI technology to match candidates to jobs automatically, saving recruiters valuable time and effort.
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-d7e39ab" data-id="d7e39ab" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-38b77ba elementor-widget elementor-widget-image" data-id="38b77ba" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img loading="lazy" decoding="async" width="800" height="800" src="./assets/images/home/vms_crm-.png" className="attachment-deepdigital-square size-deepdigital-square wp-image-6076" alt="" srcSet="./assets/images/home/vms_crm-.png 800w, ./assets/images/home/vms_crm-.png 150w" sizes="(max-width: 800px) 100vw, 800px" />													</div>
                          </div>
                          <div className="elementor-element elementor-element-4740162 elementor-widget__width-initial elementor-absolute elementor-hidden-tablet elementor-hidden-mobile elementor-widget elementor-widget-image" data-id="4740162" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;}" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img loading="lazy" decoding="async" width="34" height="136" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/left_arrow.png" className="attachment-full size-full wp-image-6734" alt="" />													</div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-753eee0" data-id="753eee0" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-b181133 elementor-widget elementor-widget-heading" data-id="b181133" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">02</h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-3a90c5f elementor-absolute e-transform elementor-widget elementor-widget-heading" data-id="3a90c5f" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;,&quot;_transform_translateY_effect&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:-50,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_tablet&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_mobile&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_widescreen&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_widescreen&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">AI-Powered Mapping</h2>		</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <div className="elementor-element elementor-element-4cc7a89 elementor-widget elementor-widget-spacer" data-id="4cc7a89" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <section className="elementor-section elementor-inner-section elementor-element elementor-element-ad03e3d elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="ad03e3d" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-51a0b3d" data-id="51a0b3d" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-e2d6b63 elementor-widget elementor-widget-heading" data-id="e2d6b63" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">03</h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-0b97037 elementor-absolute e-transform elementor-widget elementor-widget-heading" data-id="0b97037" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;,&quot;_transform_translateY_effect&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:-50,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_tablet&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_mobile&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_widescreen&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_widescreen&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">Dashboard</h2>		</div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-79949d2" data-id="79949d2" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-17fce4c elementor-widget elementor-widget-image" data-id="17fce4c" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img loading="lazy" decoding="async" width="800" height="800" src="./assets/images/home/dashboard.png" className="attachment-deepdigital-square size-deepdigital-square wp-image-6077" alt="" srcSet="./assets/images/home/dashboard.png 800w, ./assets/images/home/dashboard.png 150w" sizes="(max-width: 800px) 100vw, 800px" />													</div>
                          </div>
                          <div className="elementor-element elementor-element-3d3bf52 elementor-widget__width-initial elementor-absolute elementor-hidden-tablet elementor-hidden-mobile elementor-widget elementor-widget-image" data-id="3d3bf52" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;}" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img loading="lazy" decoding="async" width="34" height="136" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/right_arrow.png" className="attachment-full size-full wp-image-6486" alt="" />													</div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-9bcffbe" data-id="9bcffbe" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-1ad2d72 elementor-widget elementor-widget-text-editor" data-id="1ad2d72" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">
                              Foxearch's dashboards provide a comprehensive view of real-time activities, performance metrics, and resource management.

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <div className="elementor-element elementor-element-8183af5 elementor-widget elementor-widget-spacer" data-id="8183af5" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <section className="elementor-section elementor-inner-section elementor-element elementor-element-60f2912 elementor-reverse-mobile elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="60f2912" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-f49586c" data-id="f49586c" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-b0cace4 elementor-widget elementor-widget-text-editor" data-id="b0cace4" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">
                              Foxearch provides access to an extensive multi-domain candidate database network that caters to diverse industries
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-ca672f1" data-id="ca672f1" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-a7b6a3b elementor-widget elementor-widget-image" data-id="a7b6a3b" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img loading="lazy" decoding="async" width="800" height="800" src="./assets/images/home/network.jpg" className="attachment-deepdigital-square size-deepdigital-square wp-image-6076" alt="" srcSet="./assets/images/home/network.jpg 800w, ./assets/images/home/network.jpg 150w" sizes="(max-width: 800px) 100vw, 800px" />													</div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-85abcdd" data-id="85abcdd" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-e105df8 elementor-widget elementor-widget-heading" data-id="e105df8" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">04</h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-08cdc2d elementor-absolute e-transform elementor-widget elementor-widget-heading" data-id="08cdc2d" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;,&quot;_transform_translateY_effect&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:-50,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_tablet&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_mobile&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_widescreen&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_widescreen&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">Foxearch Network</h2>		</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <div className="elementor-element elementor-element-b36bb1f elementor-widget elementor-widget-spacer" data-id="b36bb1f" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div className="elementor-element elementor-element-d7c9b8f elementor-widget elementor-widget-image" data-id="d7c9b8f" data-element_type="widget" data-widget_type="image.default">
                    <div className="elementor-widget-container">
                      <img loading="lazy" decoding="async" width="5" height="94" src="./assets/images/home/white_line_big.png" className="attachment-full size-full wp-image-6055" alt="" />													</div>
                  </div>
                  <div className="elementor-element elementor-element-c7d4fef elementor-widget elementor-widget-spacer" data-id="c7d4fef" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div className="elementor-element elementor-element-dff18e4 elementor-align-center elementor-widget elementor-widget-button" data-id="dff18e4" data-element_type="widget" data-widget_type="button.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-button-wrapper">
                        <a className="elementor-button elementor-button-link elementor-size-sm" href="/productDemo">
                          <span className="elementor-button-content-wrapper">
                            <span className="elementor-button-text">Get Started</span>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* <section className="elementor-section elementor-top-section elementor-element elementor-element-527cd1f elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="527cd1f" data-element_type="section">
            <div className="elementor-container elementor-column-gap-default">
              <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-56a23f3" data-id="56a23f3" data-element_type="column">
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div className="elementor-element elementor-element-8e27cad elementor-widget elementor-widget-spacer" data-id="8e27cad" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div className="elementor-element elementor-element-c605742 elementor-widget elementor-widget-image" data-id="c605742" data-element_type="widget" data-widget_type="image.default">
                    <div className="elementor-widget-container">
                      <img loading="lazy" decoding="async" width="5" height="94" src="./assets/images/home/vertical_line.png" className="attachment-large size-large wp-image-5974" alt="" />													</div>
                  </div>
                  <div className="elementor-element elementor-element-cbc8f4a elementor-widget elementor-widget-spacer" data-id="cbc8f4a" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div className="elementor-element elementor-element-91f7e5f elementor-widget elementor-widget-gallery-carousel" data-id="91f7e5f" data-element_type="widget" data-settings="{&quot;data_responsive_lg&quot;:4,&quot;data_margin&quot;:10,&quot;items_layout&quot;:&quot;item-regular&quot;,&quot;data_loop&quot;:&quot;yes&quot;,&quot;data_autoplay&quot;:&quot;yes&quot;,&quot;data_autoplaytimeout&quot;:3000,&quot;data_center&quot;:&quot;yes&quot;,&quot;data_responsive_sm&quot;:2,&quot;data_responsive_xs&quot;:1,&quot;data_nav&quot;:&quot;yes&quot;,&quot;nav_layout&quot;:&quot;nav-layout-2&quot;}" data-widget_type="gallery-carousel.default">
                    <div className="elementor-widget-container">
                      <div className="owl-carousel-container">
                      
                        <div id="widget_portfolio_carousel_67cc049b127af" className="owl-carousel gallery-slider nav-layout-2" data-loop="true" data-autoplay="true" data-autoplaytimeout="3000" data-center="true" data-nav="true" data-margin="10" data-responsive-lg="4" data-responsive-sm="2" data-responsive-xs="1" data-filters=".carousel_filters-67cc049b127af">
                          <div className="owl-carousel-item web-design">
                            <img decoding="async" className="slide-image" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_15-800x800.jpg" alt="Sadipscing elitr sed" />																<div className="mwt-elementor-gallery-carousel-content-wrap">
                              <span className="mwt-elementor-gallery-carousel-categories">
                                Web Design										</span>
                              <a href="" className="mwt-elementor-gallery-carousel-title">
                                Sadipscing elitr sed										</a>
                            </div>
                          </div>
                          <div className="owl-carousel-item averticement">
                            <img decoding="async" className="slide-image" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_16-800x800.jpg" alt="Lorem ipsum dolor" />																<div className="mwt-elementor-gallery-carousel-content-wrap">
                              <span className="mwt-elementor-gallery-carousel-categories">
                                Averticement										</span>
                              <a href="" className="mwt-elementor-gallery-carousel-title">
                                Lorem ipsum dolor										</a>
                            </div>
                          </div>
                          <div className="owl-carousel-item logo-design">
                            <img decoding="async" className="slide-image" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_17-800x800.jpg" alt="Sitamet consetetur" />																<div className="mwt-elementor-gallery-carousel-content-wrap">
                              <span className="mwt-elementor-gallery-carousel-categories">
                                Logo Design										</span>
                              <a href="" className="mwt-elementor-gallery-carousel-title">
                                Sitamet consetetur										</a>
                            </div>
                          </div>
                          <div className="owl-carousel-item branding">
                            <img decoding="async" className="slide-image" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_8-800x800.jpg" alt="Sadipscing elitr sed diam" />																<div className="mwt-elementor-gallery-carousel-content-wrap">
                              <span className="mwt-elementor-gallery-carousel-categories">
                                Branding										</span>
                              <a href="" className="mwt-elementor-gallery-carousel-title">
                                Sadipscing elitr sed diam										</a>
                            </div>
                          </div>
                          <div className="owl-carousel-item photo">
                            <img decoding="async" className="slide-image" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_19-800x800.jpg" alt="Elitr sed diam nonumy" />																<div className="mwt-elementor-gallery-carousel-content-wrap">
                              <span className="mwt-elementor-gallery-carousel-categories">
                                Photo										</span>
                              <a href="" className="mwt-elementor-gallery-carousel-title">
                                Elitr sed diam nonumy										</a>
                            </div>
                          </div>
                          <div className="owl-carousel-item design">
                            <img decoding="async" className="slide-image" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_18-800x800.jpg" alt="Magna aliquyam erat sed" />																<div className="mwt-elementor-gallery-carousel-content-wrap">
                              <span className="mwt-elementor-gallery-carousel-categories">
                                Design										</span>
                              <a href="" className="mwt-elementor-gallery-carousel-title">
                                Magna aliquyam erat sed										</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> */}
          <section className="elementor-section elementor-top-section elementor-element elementor-element-0041dc1 elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="0041dc1" data-element_type="section">
            <div className="elementor-container elementor-column-gap-default">
              <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3451e7b" data-id="3451e7b" data-element_type="column">
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div className="elementor-element elementor-element-2df1355 members-defaults-yes members-defaults-hover-background-yes elementor-widget elementor-widget-team-slider" data-id="2df1355" data-element_type="widget" data-widget_type="team-slider.default">
                    <div className="elementor-widget-container">
                      <div className="flexslider-container mwt-team-slider-container">
                        <h3 className="slider-title mwt-elementor-team-slider-title">team</h3>
                        <div className="flexslider team-slider" data-slideshow="1" data-slideshowspeed="3000" data-animation="fade">
                        <img decoding="async" className="swiper-slide-image" src="./assets/images/home/team_slide_02.jpg" alt="team_slide_02" />                                                        
                              {/* <ul className="member-social-list">
                                <li className="elementor-icon members-list-item members-facebook">
                                  <a href="#" target="_blank">
                                    <i className="fa fa-facebook-f" />
                                  </a>
                                </li>
                                <li className="elementor-icon members-list-item members-twitter">
                                  <a href="#" target="_blank">
                                    <i className="fa fa-facebook-f" />
                                  </a>
                                </li>
                                <li className="elementor-icon members-list-item members-instagram">
                                  <a href="#" target="_blank">
                                    <i className="fa fa-instagram" />
                                  </a>
                                </li>
                              </ul> */}
                          
                        </div>
                        <div className="flexslider-controls">
                          <ul className="flex-control-nav-1">
                            {/* <li className="menu__item">
                              <span className="mwt-elementor-team-slider-name">
                                Letha L. Young                            </span>
                              <span className="mwt-elementor-team-slider-position">
                                Marketer                            </span>
                            </li>
                            <li className="menu__item">
                              <span className="mwt-elementor-team-slider-name">
                                Harold D. Cote                            </span>
                              <span className="mwt-elementor-team-slider-position">
                                Developer                            </span>
                            </li>
                            <li className="menu__item">
                              <span className="mwt-elementor-team-slider-name">
                                Oren R. Odom                            </span>
                              <span className="mwt-elementor-team-slider-position">
                                Marketer                            </span>
                            </li> */}
                            <li className="menu__item" >
                              <span className="mwt-elementor-team-slider-name" style={{ color: '#3c6ba5' }}>
                                Why Choose Us                            </span>
                              {/* <span className="mwt-elementor-team-slider-position">
                                CEO                            </span> */}
                              <div className="nrml_black" style={{ fontSize: '16px', 'margin-top': '25px' }}>
                                We understand the unique challenges that recruitment and staffing professionals face.  <br />
                                That's why we've created a comprehensive software suite designed specifically to meet your needs. <br />
                                With Foxearch, you can revolutionize your hiring and client management processes, <br />
                                streamline your sales efforts, and elevate your business to unprecedented levels of success. <br />
                                While many platforms focus solely on outcomes, often overlooking the significance of  <br />
                                process-driven workflows and the daily tasks of professionals, we take a different approach. <br />
                                We prioritize meticulous tracking and accountability of every action and interaction, <br />
                                ensuring that no detail is overlooked. Foxearch automates and organizes all information, <br />
                                presenting it in a seamless, user-friendly way, because we believe that accurate, <br />
                                well-managed data is the most valuable asset to your business
                              </div>

                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="elementor-section elementor-top-section elementor-element elementor-element-9af9a6a elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="9af9a6a" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;classNameic&quot;}">
            <div className="elementor-container elementor-column-gap-default">
              <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4c861ea" data-id="4c861ea" data-element_type="column">
                <div className="elementor-widget-wrap elementor-element-populated">
                  <section className="elementor-section elementor-inner-section elementor-element elementor-element-5392cf0 elementor-section-full_width elementor-hidden-mobile elementor-section-height-default elementor-section-height-default" data-id="5392cf0" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-44d9acb" data-id="44d9acb" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-953ab10 elementor-absolute e-transform elementor-widget elementor-widget-spacer" data-id="953ab10" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;,&quot;_transform_skewY_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:3,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_widescreen&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_tablet&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_mobile&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_widescreen&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_tablet&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_mobile&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-46b2112" data-id="46b2112" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-6d01097 elementor-absolute e-transform elementor-widget elementor-widget-spacer" data-id="6d01097" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;,&quot;_transform_skewY_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:-3,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_widescreen&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_tablet&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_mobile&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_widescreen&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_tablet&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_mobile&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <div className="elementor-element elementor-element-7e314cc elementor-align-center elementor-widget elementor-widget-button" data-id="7e314cc" data-element_type="widget" data-widget_type="button.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-button-wrapper">
                        <Link to = "/aboutUs" className="elementor-button elementor-button-link elementor-size-sm" >
                          <span className="elementor-button-content-wrapper">
                            <span className="elementor-button-text">About Us</span>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="elementor-element elementor-element-4750c32 elementor-widget elementor-widget-spacer" data-id="4750c32" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <section className="elementor-section elementor-inner-section elementor-element elementor-element-3ffb2c2 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="3ffb2c2" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-f113414" data-id="f113414" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-45d0c71 elementor-widget elementor-widget-image" data-id="45d0c71" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img decoding="async" width="5" height="94" src="./assets/images/home/vertical_line.png" className="attachment-full size-full wp-image-5974" alt="" />													</div>
                          </div>
                          <div className="elementor-element elementor-element-daf1ccd elementor-widget elementor-widget-spacer" data-id="daf1ccd" data-element_type="widget" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-038afb3 elementor-widget elementor-widget-heading" data-id="038afb3" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default" style={{ color: '#3c6ba5', textAlign:'center' }}>Comprehensive Solutions for Every Function:  </h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-1d597d8 elementor-widget elementor-widget-heading" data-id="1d597d8" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default" style={{ color: '#3c6ba5' }}> Sales, Bench Sales & Management
                              </h2>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-1b15080 elementor-widget elementor-widget-spacer" data-id="1b15080" data-element_type="widget" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-339ed86 elementor-widget elementor-widget-text-editor" data-id="339ed86" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container nrml_black">
                              We have you covered! Whether your focus is on recruitment, management, or sales, our platform seamlessly integrates all your functions in one place.
                              Introducing our innovative Smart Worksheets, meticulously designed for professionals across various domains, including Recruitment, Sales, Bench Sales and Management. Say goodbye to the chaos of scattered data sources and the frustration of searching for solutions.

                              With Foxearch, you can effortlessly work, track, and manage all your activities in a single, user-friendly interface. Experience enhanced productivity and streamlined processes like never before!
                            </div>
                          </div>
                          {/* <div className="elementor-element elementor-element-1157ba7 elementor-widget elementor-widget-spacer" data-id="1157ba7" data-element_type="widget" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div> */}
                          {/* <div className="elementor-element elementor-element-6eb7ca9 elementor-widget elementor-widget-image" data-id="6eb7ca9" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img decoding="async" width="4" height="94" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/vertical_line.png" className="attachment-full size-full wp-image-5974" alt="" />													</div>
                          </div> */}
                          {/* <div className="elementor-element elementor-element-92bb31d elementor-widget elementor-widget-spacer" data-id="92bb31d" data-element_type="widget" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </section>
                  {/* <section className="elementor-section elementor-inner-section elementor-element elementor-element-ae5d93f elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="ae5d93f" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-acf1870" data-id="acf1870" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-7376fc5 elementor-widget elementor-widget-image" data-id="7376fc5" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img loading="lazy" decoding="async" width="386" height="496" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/book-1.png" className="attachment-large size-large wp-image-6846" alt="" srcSet="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/book-1.png 386w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/book-1-233x300.png 233w" sizes="(max-width: 386px) 100vw, 386px" />													</div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-e28606f" data-id="e28606f" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-4853382 elementor-widget elementor-widget-image" data-id="4853382" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img loading="lazy" decoding="async" width="386" height="496" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/book-2.png" className="attachment-large size-large wp-image-6847" alt="" srcSet="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/book-2.png 386w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/book-2-233x300.png 233w" sizes="(max-width: 386px) 100vw, 386px" />													</div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-9e55183" data-id="9e55183" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-798cc25 elementor-widget elementor-widget-image" data-id="798cc25" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img loading="lazy" decoding="async" width="386" height="496" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/book-3.png" className="attachment-large size-large wp-image-6848" alt="" srcSet="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/book-3.png 386w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/book-3-233x300.png 233w" sizes="(max-width: 386px) 100vw, 386px" />													</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section> */}
                  <div className="elementor-element elementor-element-b03c4aa elementor-widget elementor-widget-spacer" data-id="b03c4aa" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div className="elementor-element elementor-element-5133d35 elementor-widget elementor-widget-image" data-id="5133d35" data-element_type="widget" data-widget_type="image.default">
                    <div className="elementor-widget-container">
                      <img decoding="async" width="5" height="94" src="./assets/images/home/vertical_line.png" className="attachment-full size-full wp-image-5974" alt="" />													</div>
                  </div>
                  <div className="elementor-element elementor-element-9a8402f elementor-widget elementor-widget-spacer" data-id="9a8402f" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  {/* <div className="elementor-element elementor-element-d830bc4 elementor-align-center elementor-widget elementor-widget-button" data-id="d830bc4" data-element_type="widget" data-widget_type="button.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-button-wrapper">
                        <a className="elementor-button elementor-button-link elementor-size-sm" href="">
                          <span className="elementor-button-content-wrapper">
                            <span className="elementor-button-text">Get Started</span>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="elementor-element elementor-element-250e00d elementor-widget elementor-widget-spacer" data-id="250e00d" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="elementor-element elementor-element-d15a225 elementor-widget elementor-widget-image" data-id="d15a225" data-element_type="widget" data-widget_type="image.default">
                    <div className="elementor-widget-container">
                      <img decoding="async" width="4" height="94" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/vertical_line.png" className="attachment-full size-full wp-image-5974" alt="" />													</div>
                  </div> */}
                  {/* <div className="elementor-element elementor-element-5351c98 elementor-widget elementor-widget-spacer" data-id="5351c98" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </section>
          <section className="elementor-section elementor-top-section elementor-element elementor-element-cec7ea2 elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="cec7ea2" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;classNameic&quot;}">
            <div className="elementor-container elementor-column-gap-default">
              <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-0b7ab5e" data-id="0b7ab5e" data-element_type="column">
                <div className="elementor-widget-wrap elementor-element-populated">
                  <section className="elementor-section elementor-inner-section elementor-element elementor-element-b43b2f2 elementor-section-full_width elementor-hidden-mobile elementor-section-height-default elementor-section-height-default" data-id="b43b2f2" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-e97740e" data-id="e97740e" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-b48e15d elementor-absolute e-transform elementor-widget elementor-widget-spacer" data-id="b48e15d" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;,&quot;_transform_skewY_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:3,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_widescreen&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_tablet&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_mobile&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_widescreen&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_tablet&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_mobile&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-b6cdbfd" data-id="b6cdbfd" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-124ace2 elementor-absolute e-transform elementor-widget elementor-widget-spacer" data-id="124ace2" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;,&quot;_transform_skewY_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:-3,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_widescreen&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_tablet&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_mobile&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_widescreen&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_tablet&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_mobile&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  {/* <section className="elementor-section elementor-inner-section elementor-element elementor-element-e1b2a2b elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="e1b2a2b" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-74d1ab3" data-id="74d1ab3" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-a1f4282 elementor-widget elementor-widget-posts-carousel" data-id="a1f4282" data-element_type="widget" data-settings="{&quot;data_margin&quot;:4,&quot;data_responsive_lg&quot;:4,&quot;data_loop&quot;:&quot;yes&quot;,&quot;data_autoplay&quot;:&quot;yes&quot;,&quot;data_autoplaytimeout&quot;:3000,&quot;data_responsive_sm&quot;:2,&quot;data_responsive_xs&quot;:1}" data-widget_type="posts-carousel.default">
                            <div className="elementor-widget-container">
                              <div className="owl-carousel-container mwt-elementor-posts-carousel">
                                <div id="widget_portfolio_carousel_67cc049b1a88e" className="owl-carousel posts-slider " data-prev="Prev post" data-next="Next post" data-loop="true" data-autoplay="true" data-autoplaytimeout="3000" data-center="false" data-nav="false" data-margin="4" data-responsive-lg="4" data-responsive-sm="2" data-responsive-xs="1" data-filters=".carousel_filters-67cc049b1a88e">
                                  <div className="owl-carousel-item web-design-blog-masonry ">
                                    <article className="mwt-elementor-posts-carousel-article post-9081 post type-post status-publish format-standard has-post-thumbnail hentry category-web-design-blog-masonry tag-design">
                                      <div className="mwt-elementor-posts-carousel-item-content">
                                        <div className="mwt-elementor-posts-carousel-date">
                                          <a href="https://webdesign-finder.com/deepdigital-v2/post-format-standart-2-2-2/">May 20, 2023</a>
                                        </div>
                                        <h4 className="mwt-elementor-posts-carousel-post-title">
                                          <a className="mwt-elementor-posts-carousel-title" href="https://webdesign-finder.com/deepdigital-v2/post-format-standart-2-2-2/">Sample post with image</a>
                                        </h4>
                                        <div className="mwt-elementor-posts-carousel-author">
                                          <a href="https://webdesign-finder.com/deepdigital-v2/author/emmajohnson/"> emmajohnson</a>
                                        </div>
                                      </div>
                                    </article>
                                  </div>
                                  <div className="owl-carousel-item averticement-blog-masonry ">
                                    <article className="mwt-elementor-posts-carousel-article post-9079 post type-post status-publish format-gallery has-post-thumbnail hentry category-averticement-blog-masonry tag-averticement tag-design post_format-post-format-gallery">
                                      <div className="mwt-elementor-posts-carousel-item-content">
                                        <div className="mwt-elementor-posts-carousel-date">
                                          <a href="https://webdesign-finder.com/deepdigital-v2/post-with-carousel-3-2/">May 20, 2023</a>
                                        </div>
                                        <h4 className="mwt-elementor-posts-carousel-post-title">
                                          <a className="mwt-elementor-posts-carousel-title" href="https://webdesign-finder.com/deepdigital-v2/post-with-carousel-3-2/">Post With Carousel</a>
                                        </h4>
                                        <div className="mwt-elementor-posts-carousel-author">
                                          <a href="https://webdesign-finder.com/deepdigital-v2/author/emmajohnson/"> emmajohnson</a>
                                        </div>
                                      </div>
                                    </article>
                                  </div>
                                  <div className="owl-carousel-item logo-design-blog-masonry ">
                                    <article className="mwt-elementor-posts-carousel-article post-9077 post type-post status-publish format-video has-post-thumbnail hentry category-logo-design-blog-masonry tag-design post_format-post-format-video">
                                      <div className="mwt-elementor-posts-carousel-item-content">
                                        <div className="mwt-elementor-posts-carousel-date">
                                          <a href="https://webdesign-finder.com/deepdigital-v2/post-format-video-youtube-2-2-2/">May 20, 2023</a>
                                        </div>
                                        <h4 className="mwt-elementor-posts-carousel-post-title">
                                          <a className="mwt-elementor-posts-carousel-title" href="https://webdesign-finder.com/deepdigital-v2/post-format-video-youtube-2-2-2/">Sample post with YouTube video</a>
                                        </h4>
                                        <div className="mwt-elementor-posts-carousel-author">
                                          <a href="https://webdesign-finder.com/deepdigital-v2/author/emmajohnson/"> emmajohnson</a>
                                        </div>
                                      </div>
                                    </article>
                                  </div>
                                  <div className="owl-carousel-item web-design-blog-right-sidebar ">
                                    <article className="mwt-elementor-posts-carousel-article post-9035 post type-post status-publish format-standard has-post-thumbnail hentry category-web-design-blog-right-sidebar tag-design">
                                      <div className="mwt-elementor-posts-carousel-item-content">
                                        <div className="mwt-elementor-posts-carousel-date">
                                          <a href="https://webdesign-finder.com/deepdigital-v2/post-format-standart-2-2/">May 20, 2023</a>
                                        </div>
                                        <h4 className="mwt-elementor-posts-carousel-post-title">
                                          <a className="mwt-elementor-posts-carousel-title" href="https://webdesign-finder.com/deepdigital-v2/post-format-standart-2-2/">Sample post with image</a>
                                        </h4>
                                        <div className="mwt-elementor-posts-carousel-author">
                                          <a href="https://webdesign-finder.com/deepdigital-v2/author/emmajohnson/"> emmajohnson</a>
                                        </div>
                                      </div>
                                    </article>
                                  </div>
                                  <div className="owl-carousel-item averticement-blog-right-sidebar ">
                                    <article className="mwt-elementor-posts-carousel-article post-9039 post type-post status-publish format-gallery has-post-thumbnail hentry category-averticement-blog-right-sidebar tag-averticement tag-design post_format-post-format-gallery">
                                      <div className="mwt-elementor-posts-carousel-item-content">
                                        <div className="mwt-elementor-posts-carousel-date">
                                          <a href="https://webdesign-finder.com/deepdigital-v2/post-with-carousel-3/">May 20, 2023</a>
                                        </div>
                                        <h4 className="mwt-elementor-posts-carousel-post-title">
                                          <a className="mwt-elementor-posts-carousel-title" href="https://webdesign-finder.com/deepdigital-v2/post-with-carousel-3/">Post With Carousel</a>
                                        </h4>
                                        <div className="mwt-elementor-posts-carousel-author">
                                          <a href="https://webdesign-finder.com/deepdigital-v2/author/emmajohnson/"> emmajohnson</a>
                                        </div>
                                      </div>
                                    </article>
                                  </div>
                                  <div className="owl-carousel-item logo-design-blog-right-sidebar ">
                                    <article className="mwt-elementor-posts-carousel-article post-9043 post type-post status-publish format-video has-post-thumbnail hentry category-logo-design-blog-right-sidebar tag-design post_format-post-format-video">
                                      <div className="mwt-elementor-posts-carousel-item-content">
                                        <div className="mwt-elementor-posts-carousel-date">
                                          <a href="https://webdesign-finder.com/deepdigital-v2/post-format-video-youtube-2-2/">May 20, 2023</a>
                                        </div>
                                        <h4 className="mwt-elementor-posts-carousel-post-title">
                                          <a className="mwt-elementor-posts-carousel-title" href="https://webdesign-finder.com/deepdigital-v2/post-format-video-youtube-2-2/">Sample post with YouTube video</a>
                                        </h4>
                                        <div className="mwt-elementor-posts-carousel-author">
                                          <a href="https://webdesign-finder.com/deepdigital-v2/author/emmajohnson/"> emmajohnson</a>
                                        </div>
                                      </div>
                                    </article>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section> */}
                  <div className="elementor-element elementor-element-b45ec7d elementor-widget elementor-widget-spacer" data-id="b45ec7d" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div className="elementor-element elementor-element-9b2bdac elementor-widget elementor-widget-image" data-id="9b2bdac" data-element_type="widget" data-widget_type="image.default">
                    <div className="elementor-widget-container">
                      <img loading="lazy" decoding="async" width="5" height="94" src="./assets/images/home/white_line_big.png" style={{ 'position': 'relative', 'z-index': '2' }} className="attachment-full size-full wp-image-6055" alt="" />													</div>
                  </div>
                  <div className="elementor-element elementor-element-c1e34fc elementor-widget elementor-widget-spacer" data-id="c1e34fc" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <section className="elementor-section elementor-inner-section elementor-element elementor-element-042ae27 elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="042ae27" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-460390e" data-id="460390e" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-a63ed4b elementor-widget elementor-widget-testimonials-carousel" data-id="a63ed4b" data-element_type="widget" data-settings="{&quot;item_layout&quot;:&quot;single_carousel&quot;,&quot;data_loop&quot;:&quot;yes&quot;,&quot;data_autoplay&quot;:&quot;yes&quot;,&quot;data_autoplaytimeout&quot;:3000,&quot;data_margin&quot;:15,&quot;data_nav&quot;:&quot;yes&quot;,&quot;data_dots&quot;:&quot;yes&quot;}" data-widget_type="testimonials-carousel.default">
                            <div className="elementor-widget-container">
                              <div className="owl-carousel-container mwt-testimonials-carousel testimonials-single-carousel">
                                <div id="widget_portfolio_carousel_67cc049b1d9d6" className="owl-carousel testimonials-slider" data-loop="true" data-autoplay="true" data-autoplaytimeout="3000" data-center="false" data-nav="true" data-dots="true" data-margin="15" data-responsive-lg="1" data-responsive-sm="1" data-responsive-xs="1">
                                  <div className="owl-carousel-item text-center">
                                    <div className="mwt-elementor-testimonials-carousel-image-wrap">
                                      <img decoding="async" className="mwt-elementor-testimonials-carousel-image" src="./assets/images/home/testimonials_1.jpg" alt="Josephine B. Anderson" />								</div>
                                    <div className="mwt-elementor-testimonials-carousel-position">
                                    Triveni IT							</div>

                                    <div className="mwt-elementor-testimonials-carousel-name">
                                    Jwalit Shah						</div>

                                    <div className="mwt-elementor-testimonials-carousel-quote">
                                      <span className="mwt-elementor-testimonials-carousel-quote-icon" />
                                      {/* </span> */}
                                      This ATS is incredibly user-friendly with smart worksheets and a powerful AI that simplifies tracking and managing applicants.
The dashboard gives real-time insights and keeps our hiring process smooth and efficient.

                                      <span className="mwt-elementor-testimonials-carousel-quote-icon" />
                                      {/* </span> */}
                                    </div>
                                  </div>
                                  <div className="owl-carousel-item text-center">
                                    <div className="mwt-elementor-testimonials-carousel-image-wrap">
                                      <img decoding="async" className="mwt-elementor-testimonials-carousel-image" src="./assets/images/home/testimonials_2.jpg" alt="George M. Baty" />								</div>
                                    <div className="mwt-elementor-testimonials-carousel-position">
                                    Rooney Recruiting 							</div>

                                    <div className="mwt-elementor-testimonials-carousel-name">
                                    Mike Rooney 							</div>

                                    <div className="mwt-elementor-testimonials-carousel-quote">
                                      <span className="mwt-elementor-testimonials-carousel-quote-icon" />
                                      {/* </span> */}
                                      The sleek, simple UI makes navigation effortless, and the smart features truly elevate the hiring experience.
AI suggestions and smart worksheets save time while keeping our team perfectly aligned.

                                      <span className="mwt-elementor-testimonials-carousel-quote-icon" />
                                      {/* </span> */}
                                    </div>
                                  </div>
                                  <div className="owl-carousel-item text-center">
                                    <div className="mwt-elementor-testimonials-carousel-image-wrap">
                                      <img decoding="async" className="mwt-elementor-testimonials-carousel-image" src="./assets/images/home/testimonials_3.jpg" alt="Jeffrey P. McAllister" />								</div>
                                    <div className="mwt-elementor-testimonials-carousel-position">
                                    Radiumspark Inc							</div>

                                    <div className="mwt-elementor-testimonials-carousel-name">
                                    Ripudaman Talwar							</div>

                                    <div className="mwt-elementor-testimonials-carousel-quote">
                                      <span className="mwt-elementor-testimonials-carousel-quote-icon" />
                                      {/* </span> */}
                                      An amazing all-in-one ATS—intuitive, efficient, and loaded with smart tools that make recruiting a breeze.
From tracking to managing, everything is streamlined thanks to a brilliant dashboard and AI features.
                                      <span className="mwt-elementor-testimonials-carousel-quote-icon" />
                                      {/* </span> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <div className="elementor-element elementor-element-83221e8 elementor-widget elementor-widget-spacer" data-id="83221e8" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  {/* <div className="elementor-element elementor-element-89ea405 elementor-widget elementor-widget-image" data-id="89ea405" data-element_type="widget" data-widget_type="image.default">
                    <div className="elementor-widget-container">
                      <img loading="lazy" decoding="async" width="4" height="94" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/vertical_line2.png" className="attachment-full size-full wp-image-6055" alt="" />
                    </div>
                  </div> */}
                  {/* <div className="elementor-element elementor-element-2b8f3de elementor-widget elementor-widget-spacer" data-id="2b8f3de" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </section>
          <section className="elementor-section elementor-top-section elementor-element elementor-element-61a00d0 elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="61a00d0" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;classNameic&quot;}">
            <div className="elementor-container elementor-column-gap-default">
              <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2696be4" data-id="2696be4" data-element_type="column">
                <div className="elementor-widget-wrap elementor-element-populated">
                  <section className="elementor-section elementor-inner-section elementor-element elementor-element-b329ee8 elementor-section-full_width elementor-hidden-mobile elementor-section-height-default elementor-section-height-default" data-id="b329ee8" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-c3a6794" data-id="c3a6794" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-75a9820 elementor-absolute e-transform elementor-widget elementor-widget-spacer" data-id="75a9820" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;,&quot;_transform_skewY_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:3,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_widescreen&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_tablet&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_mobile&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_widescreen&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_tablet&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_mobile&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-f6e9c88" data-id="f6e9c88" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-f13332e elementor-absolute e-transform elementor-widget elementor-widget-spacer" data-id="f13332e" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;,&quot;_transform_skewY_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:-3,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_widescreen&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_tablet&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewX_effect_mobile&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_widescreen&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_tablet&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_skewY_effect_mobile&quot;:{&quot;unit&quot;:&quot;deg&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  {/* <div className="elementor-element elementor-element-d505472 elementor-align-center elementor-widget elementor-widget-button" data-id="d505472" data-element_type="widget" data-widget_type="button.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-button-wrapper">
                        <a className="elementor-button elementor-button-link elementor-size-sm" href="">
                          <span className="elementor-button-content-wrapper">
                            <span className="elementor-button-text">More</span>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div> */}
                  <div className="elementor-element elementor-element-66f94ba elementor-widget elementor-widget-spacer" data-id="66f94ba" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <section className="elementor-section elementor-inner-section elementor-element elementor-element-e4b463c elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="e4b463c" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-12ce420" data-id="12ce420" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-46316d6 elementor-widget elementor-widget-image" data-id="46316d6" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img decoding="async" width="5" height="94" src="./assets/images/home/vertical_line.png" className="attachment-full size-full wp-image-5974" alt="" />													</div>
                          </div>
                          <div className="elementor-element elementor-element-2014c6e elementor-widget elementor-widget-spacer" data-id="2014c6e" data-element_type="widget" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-0c23d0d elementor-widget elementor-widget-heading" data-id="0c23d0d" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default" style={{ color: '#3c6ba5' }}>Security</h2>
                            </div>
                          </div>
                          {/* <div className="elementor-element elementor-element-4e8cb8c elementor-widget elementor-widget-heading" data-id="4e8cb8c" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">Your Project</h2>		</div>
                          </div> */}
                          <div className="elementor-element elementor-element-981afbb elementor-widget elementor-widget-spacer" data-id="981afbb" data-element_type="widget" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-c28aba2 elementor-widget elementor-widget-text-editor" data-id="c28aba2" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container nrml_black">
                              At Foxearch, we recognize the critical importance of safeguarding sensitive data. That's why we employ cutting-edge security protocols to ensure that your information remains confidential and protected at all times. You can have peace of mind knowing that your business data is in trusted hands, with robust security measures in place to safeguard it from any threat.
                              Join the growing community of recruitment and staffing professionals who have already experienced the Foxearch advantage. Streamline your operations, optimize results, and scale your business with complete confidence.
                              Ready to discover how Foxearch can transform your recruitment and staffing processes? Contact us today for a personalized demo!

                            </div>
                          </div>
                          <div className="elementor-element elementor-element-58b3620 elementor-widget elementor-widget-spacer" data-id="58b3620" data-element_type="widget" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-9044ac1 elementor-widget elementor-widget-image" data-id="9044ac1" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img decoding="async" width="5" height="94" src="./assets/images/home/vertical_line.png" className="attachment-full size-full wp-image-5974" alt="" />													</div>
                          </div>
                          {/* <div className="elementor-element elementor-element-28f99bc elementor-widget elementor-widget-spacer" data-id="28f99bc" data-element_type="widget" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div> */}
                          {/* <div className="elementor-element elementor-element-85e1b1c elementor-align-center elementor-widget elementor-widget-button" data-id="85e1b1c" data-element_type="widget" data-widget_type="button.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-button-wrapper">
                                <a className="elementor-button elementor-button-link elementor-size-sm" href="">
                                  <span className="elementor-button-content-wrapper">
                                    <span className="elementor-button-text">Let’s Talk!</span>
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div> */}
                          {/* <div className="elementor-element elementor-element-29881fc elementor-widget elementor-widget-spacer" data-id="29881fc" data-element_type="widget" data-widget_type="spacer.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div> */}
                          {/* <div className="elementor-element elementor-element-bdfc3e2 elementor-widget elementor-widget-image" data-id="bdfc3e2" data-element_type="widget" data-widget_type="image.default">
                            <div className="elementor-widget-container">
                              <img decoding="async" width="4" height="94" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/vertical_line.png" className="attachment-full size-full wp-image-5974" alt="" />													</div>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </section>

                </div>
              </div>
            </div>
          </section>
          <section className="elementor-section elementor-top-section elementor-element elementor-element-7276a38 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="7276a38" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;classNameic&quot;}">
            <div className="elementor-container elementor-column-gap-default">
              <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-bdc2f38" data-id="bdc2f38" data-element_type="column">
                <div className="elementor-widget-wrap elementor-element-populated">
                  {/* <div className="elementor-element elementor-element-29f686b elementor-widget elementor-widget-spacer" data-id="29f686b" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="elementor-element elementor-element-22e819f elementor-widget elementor-widget-image" data-id="22e819f" data-element_type="widget" data-widget_type="image.default">
                    <div className="elementor-widget-container">
                      <img loading="lazy" decoding="async" width="4" height="94" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/vertical_line3.png" className="attachment-large size-large wp-image-6056" alt="" />													</div>
                  </div> */}
                  <div className="elementor-element elementor-element-edbaff0 elementor-widget elementor-widget-spacer" data-id="edbaff0" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container" >
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  {/* <section className="elementor-section elementor-inner-section elementor-element elementor-element-a1f96d8 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="a1f96d8" data-element_type="section">
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-ace5f99" data-id="ace5f99" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-c423f8e elementor-view-stacked elementor-shape-circle elementor-widget elementor-widget-icon" data-id="c423f8e" data-element_type="widget" data-widget_type="icon.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-icon-wrapper">
                                <div className="elementor-icon elementor-animation-pop">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">
                                    <path d="M768 0h-512c-53.056 0-96 42.976-96 96v832c0 53.056 42.976 96 96 96h512c52.992 0 96-43.008 96-96v-832c0-53.056-43.008-96-96-96zM800 928c0 17.632-14.368 32-32 32h-512c-17.664 0-32-14.304-32-32v-64.128h576v64.128zM800 831.872h-576v-639.872h576v639.872zM800 160h-576v-64c0-17.664 14.336-32 32-32h512c17.632 0 32 14.336 32 32v64zM576 112c0 8.832-7.2 16-16 16h-96c-8.864 0-16-7.168-16-16v0c0-8.864 7.136-16 16-16h96c8.8 0 16 7.136 16 16v0zM544 911.872c0 8.8-7.2 16-16 16h-32c-8.832 0-16-7.2-16-16v0c0-8.864 7.168-16 16-16h32c8.8 0 16 7.136 16 16v0z" />
                                  </svg>			</div>
                              </div>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-d9d7571 elementor-widget elementor-widget-heading" data-id="d9d7571" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">ATS - Applicant Tracking System
                              </h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-dae59b9 elementor-widget elementor-widget-text-editor" data-id="dae59b9" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">
                            
                              Recruiting is your expertise, and <strong>Foxearch</strong> is the tool that takes it to the next level. Our <strong>AI-powered ATS</strong> simplifies every aspect of the hiring process—from posting jobs to managing candidates—ensuring you stay organized and collaborate effortlessly. With intelligent candidate mapping, real-time dashboards, and a user-friendly interface, Foxearch empowers you to find the perfect candidates faster and transform your recruitment process into a seamless and efficient experience.

                             
                              				</div>
                          </div> 
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-12f7cb6" data-id="12f7cb6" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-ecec80f elementor-view-stacked elementor-shape-circle elementor-widget elementor-widget-icon" data-id="ecec80f" data-element_type="widget" data-widget_type="icon.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-icon-wrapper">
                                <div className="elementor-icon elementor-animation-pop">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">
                                    <path d="M940.64 82.56c-52.64-52.576-121.952-82.56-190.272-82.56-57.632 0-110.688 21.376-149.44 60.064l-155.744 156.928c-0.48 0.448-1.024 0.736-1.504 1.216-0.256 0.256-0.416 0.608-0.672 0.832l0.064 0.064-330.528 333.088c-15.232 15.136-26.272 33.984-32.416 54.56l-75.168 272.256c-0.064 0.736-4.96 22.112-4.96 32.992 0 61.824 50.208 112 112.128 112 12.32 0 36.16-5.888 37.024-6.016l271.296-71.328c20.608-6.112 39.328-17.248 54.56-32.512l488.416-492.256c88.832-88.896 78.816-237.888-22.784-339.328zM512.448 761.44c-2.624-28.864-10.784-57.184-23.008-84.064l302.56-302.528c18.496 58.432 8.992 119.552-31.552 160.128-0.256 0.256-0.576 0.416-0.8 0.672l0.448 0.416-247.296 249.28c0-7.968 0.384-15.776-0.352-23.904zM473.376 648.192c-11.936-19.616-25.504-38.56-42.304-55.328-19.552-19.552-41.984-34.88-65.408-47.744l305.024-305.024c23.936 10.624 46.88 25.76 67.136 46.016 17.312 17.248 30.688 36.576 40.992 56.672l-305.44 305.408zM335.552 529.984c-29.632-11.936-60.672-18.752-91.776-19.168l246.496-248.384c37.728-36.8 92.672-47.392 146.784-33.984l-301.504 301.536zM133.344 955.936c-3.488 0.8-14.336 3.552-21.696 4.064-26.304-0.32-47.648-21.696-47.648-48 0.384-5.376 2.528-14.624 3.264-17.984l33.696-122.048c36.576-0.992 75.936 13.248 106.88 44.256 31.424 31.36 46.208 71.488 44.608 108.512l-119.104 31.2zM283.968 916.384c-0.768-42.944-18.24-87.616-53.504-122.816-33.344-33.376-76.992-52.64-120.512-54.368l31.872-115.424c2.304-7.68 6.88-15.264 12.512-21.888 64.192-45.952 162.912-32.384 231.488 36.256 72.544 72.512 83.744 178.752 27.872 242.176-3.712 1.952-7.456 3.808-11.488 4.992l-118.24 31.072zM918.112 376.704l-53.888 54.304c0-7.232 0.864-14.176 0.192-21.568-5.632-61.92-34.496-121.792-81.376-168.608-52.128-52.16-121.248-82.080-189.696-82.272l52.992-53.44c26.528-26.464 63.552-41.12 104.032-41.12 51.488 0 104.384 23.296 145.056 63.84 38.176 38.112 60.928 85.472 64.192 133.376 3.008 44.704-11.744 85.696-41.504 115.488z"
                                    /></svg>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-ec71f62 elementor-widget elementor-widget-heading" data-id="ec71f62" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">VMS/CRM - Vendor Management System
                              </h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-c32f938 elementor-widget elementor-widget-text-editor" data-id="c32f938" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">
                             
                              Effortlessly manage your clients, job postings, and vendor relationships with <strong>Foxearch's VMS/CRM.</strong> Designed for seamless efficiency, our system enables you to oversee multiple clients, monitor vendor performance, and ensure timely candidate delivery—all from a single, intuitive platform. With real-time tracking and centralized data management, Foxearch eliminates administrative complexities, allowing you to focus on building stronger client and vendor relationships. 

                              		</div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-daa7569" data-id="daa7569" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-2502c55 elementor-view-stacked elementor-shape-circle elementor-widget elementor-widget-icon" data-id="2502c55" data-element_type="widget" data-widget_type="icon.default">
                            <div className="elementor-widget-container">
                              <div className="elementor-icon-wrapper">
                                <div className="elementor-icon elementor-animation-pop">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">
                                    <path d="M512.064 567.872c105.888 0 192-86.144 192-192s-86.112-192-192-192c-105.888 0-192 86.112-192 192s86.112 192 192 192zM512.064 215.872c88.256 0 160 71.744 160 160s-71.744 160-160 160c-88.256 0-160-71.744-160-160s71.744-160 160-160zM512 0c-211.776 0-384 170.112-384 384.032 0 224 192.032 453.152 332.032 614.208 0.512 0.64 22.976 25.76 50.752 25.76 0.064 0 2.336 0 2.464 0 27.744 0 50.24-25.12 50.752-25.76 140.064-161.056 332.064-390.176 332.064-614.208 0-213.92-172.256-384.032-384.064-384.032zM515.744 956.256c-0.672 0.64-2.624 2.048-4.32 3.136-0.32-0.864-2.688-2.752-4.128-4.256-117.28-134.944-315.296-362.688-315.296-571.104 0-176.448 143.584-320.032 320-320.032 176.512 0 320.064 143.584 320.064 320.064 0 208.384-198.016 436.128-316.32 572.192z"
                                    /></svg>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-42176b7 elementor-widget elementor-widget-heading" data-id="42176b7" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">SOS - Sales Optimization System</h2>		</div>
                          </div>
                          <div className="elementor-element elementor-element-5e82667 elementor-widget elementor-widget-text-editor" data-id="5e82667" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">
                             
                              Elevate your sales operations and client relationship management with <strong>Foxearch's SOS (Sales Optimization System).</strong> Specifically designed for recruitment and staffing companies, this powerful system simplifies every aspect of the sales process—from tracking leads to managing client communications. With its intuitive interface, Foxearch's SOS ensures seamless collaboration, enhanced client engagement, and real-time insights into sales performance.

                              			</div>
                          </div> 
                        </div>
                      </div>
                    </div>
                  </section> */}
                  {/* <div className="elementor-element elementor-element-a7fada6 elementor-widget elementor-widget-spacer" data-id="a7fada6" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="elementor-element elementor-element-d0fb4ba elementor-widget elementor-widget-image" data-id="d0fb4ba" data-element_type="widget" data-widget_type="image.default">
                    <div className="elementor-widget-container">
                      <img loading="lazy" decoding="async" width="4" height="94" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/vertical_line3.png" className="attachment-large size-large wp-image-6056" alt="" />													</div>
                  </div> */}
                  <div className="elementor-element elementor-element-70b91a1 elementor-widget elementor-widget-spacer" data-id="70b91a1" data-element_type="widget" data-widget_type="spacer.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* <footer id="footer" className="footer footer-8 text-center i fs-14 " style={{'background-image':'url(https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/06/footer_bg-1.png)'}}>
		<div className="left_part i " style={{'background-image': 'url(https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/06/footer_bg-1.png)'}} />
	<div className="right_part i " style={{'background-image': 'url(https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/06/footer_bg-1.png)'}} />
	<div className="container pt-0 pb-6">
				<div className="layout-cols-1 layout-gap-30">
			<aside className="footer-widgets cols-1">
<div id="theme-meta-6" className="widget-odd widget-last widget-first widget-1 margin-negative grid-item widget widget_theme_meta animated fadeInUp" data-animate="fadeInUp">
  <div className="widget-theme-meta-default "><div className="theme-meta-img wp-block-image"><img src="./assets/logo_pink.jpeg" alt="" />
  </div>
  <span className="social-links"><a href="#" target="_blank" className="social-icon social-icon-twitter">
    <span className="svg-icon icon-twitter">
      <svg viewBox="0 0 24 24" width="24" height="24">
	    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
     </svg>
</span>
</a>
<a href="#" target="_blank" className="social-icon social-icon-facebook">
  <span className="svg-icon icon-facebook">
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
	  <path d="M304 96h80v-96h-80c-61.757 0-112 50.243-112 112v48h-64v96h64v256h96v-256h80l16-96h-96v-48c0-8.673 7.327-16 16-16z" />
  </svg>
  </span>
</a>
<a href="#" target="_blank" className="social-icon social-icon-instagram">
  <span className="svg-icon icon-instagram">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
	<path d="M256 46.1c68.4 0 76.5 0.3 103.4 1.5 25 1.1 38.5 5.3 47.5 8.8 11.9 4.6 20.5 10.2 29.4 19.1 9 9 14.5 17.5 19.2 29.4 3.5 9 7.7 22.6 8.8 47.5 1.2 27 1.5 35.1 1.5 103.4s-0.3 76.5-1.5 103.4c-1.1 25-5.3 38.5-8.8 47.5-4.6 11.9-10.2 20.5-19.1 29.4-9 9-17.5 14.5-29.4 19.2-9 3.5-22.6 7.7-47.5 8.8-27 1.2-35.1 1.5-103.4 1.5s-76.5-0.3-103.4-1.5c-25-1.1-38.5-5.3-47.5-8.8-11.9-4.6-20.5-10.2-29.4-19.1-9-9-14.5-17.5-19.2-29.4-3.5-9-7.7-22.6-8.8-47.5-1.2-27-1.5-35.1-1.5-103.4s0.3-76.5 1.5-103.4c1.1-25 5.3-38.5 8.8-47.5 4.6-11.9 10.2-20.5 19.1-29.4 9-9 17.5-14.5 29.4-19.2 9-3.5 22.6-7.7 47.5-8.8 26.9-1.2 35-1.5 103.4-1.5zM256 0c-69.5 0-78.2 0.3-105.5 1.5-27.2 1.2-45.9 5.6-62.1 11.9-16.9 6.6-31.2 15.3-45.4 29.6-14.3 14.2-23 28.5-29.6 45.3-6.3 16.3-10.7 34.9-11.9 62.1-1.2 27.4-1.5 36.1-1.5 105.6s0.3 78.2 1.5 105.5c1.2 27.2 5.6 45.9 11.9 62.1 6.6 16.9 15.3 31.2 29.6 45.4 14.2 14.2 28.5 23 45.3 29.5 16.3 6.3 34.9 10.7 62.1 11.9 27.3 1.2 36 1.5 105.5 1.5s78.2-0.3 105.5-1.5c27.2-1.2 45.9-5.6 62.1-11.9 16.8-6.5 31.1-15.3 45.3-29.5s23-28.5 29.5-45.3c6.3-16.3 10.7-34.9 11.9-62.1 1.2-27.3 1.5-36 1.5-105.5s-0.3-78.2-1.5-105.5c-1.2-27.2-5.6-45.9-11.9-62.1-6.3-17-15-31.3-29.3-45.5-14.2-14.2-28.5-23-45.3-29.5-16.3-6.3-34.9-10.7-62.1-11.9-27.4-1.3-36.1-1.6-105.6-1.6v0z" />
	<path d="M256 124.5c-72.6 0-131.5 58.9-131.5 131.5s58.9 131.5 131.5 131.5 131.5-58.9 131.5-131.5c0-72.6-58.9-131.5-131.5-131.5zM256 341.3c-47.1 0-85.3-38.2-85.3-85.3s38.2-85.3 85.3-85.3c47.1 0 85.3 38.2 85.3 85.3s-38.2 85.3-85.3 85.3z" />
	<path d="M423.4 119.3c0 16.955-13.745 30.7-30.7 30.7s-30.7-13.745-30.7-30.7c0-16.955 13.745-30.7 30.7-30.7s30.7 13.745 30.7 30.7z" />
</svg>
</span></a>
<a href="#" target="_blank" className="social-icon social-icon-youtube">
  <span className="svg-icon icon-youtube">
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="24" height="24" viewBox="0 0 24 24">
	<path d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z" />
</svg>
</span></a><a href="#" target="_blank" className="social-icon social-icon-linkedin"><span className="svg-icon icon-linkedin"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">
	<path d="M384 384h177.106v90.782h2.532c24.64-44.194 84.958-90.782 174.842-90.782 186.946 0 221.52 116.376 221.52 267.734v308.266h-184.61v-273.278c0-65.184-1.334-149.026-96.028-149.026-96.148 0-110.82 70.986-110.82 144.292v278.012h-184.542v-576zM64 384h192v576h-192v-576zM256 224c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z" />
</svg></span></a></span></div>
</div>			</aside>
		</div>
			</div>
	</footer>
        <div id="copyright" className="copyright i c fs-12 " >
          <div className="container pt-2 pb-2">
            <div className="copyright-text color-dark text-center">
              © Copyright <span className="copyright-year">2025</span> All Rights Reserved		</div>
          </div>
        </div> */}
        <Footer />
      </div>
    </>
  );
}

export default Home;